<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-shopping-cart" titulo="PEDIDO DE VENDA">
      <template #subtitulo>
        <i class="fa fa-tag mr-1 text-info"></i>
        Pedido: <strong class="text-white">{{ venda.SEQUENCIA > 0 ? venda.SEQUENCIA : 'Novo' }}</strong>
        <span class="mx-2">•</span>
        <i class="fa fa-user mr-1 text-info"></i>
        Cliente: <strong class="text-white">{{ cliente.CODIGO }} - {{ cliente.NOME }}</strong>
      </template>

      <template #acoes>
        <b-button v-if="habilitaBotaoFinalizar" variant="link" class="btn-glass btn-glass-success" @click="finalizarVenda()">
          <i class="fa fa-check mr-1"></i> LIBERAR PRA ORDEM <small>F11</small>
        </b-button>

        <b-button v-if="habilitaBotaoLiberarTerminal" variant="link" class="btn-glass btn-glass-info" @click="liberarProTerminal()">
          <i class="fa fa-truck mr-1"></i> LIBERAR TERMINAL <small>F11</small>
        </b-button>

        <b-button v-if="habilitaBotaoSolicitarConferencia" variant="link" class="btn-glass btn-glass-info" @click="solicitarConferencia()">
          <i class="fa fa-barcode mr-1"></i> SOLICITAR SEPARACAO <small>F11</small>
        </b-button>

        <b-button v-if="habilitaBotaoGravar" variant="link" class="btn-glass btn-glass-primary" @click="gravarPedidoEVoltar()">
          <i class="fa fa-save mr-1"></i> GRAVAR <small>F10</small>
        </b-button>

        <b-button v-if="habilitaBotaoExcluir" variant="link" class="btn-glass btn-glass-danger" @click="abrirModalCancelamento()">
          <i class="fa fa-close mr-1"></i> CANCELAR
        </b-button>

        <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click.stop.prevent="voltar()">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="page-main px-3">
      <div style="max-height: 80vh; overflow-y: auto; overflow-x: hidden;" class="pr-2">
        <!-- Main Summary Bar -->
        <b-row class="mb-4 mt-2">
           <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-secondary" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Situação</small>
              <h5 class="mb-0 font-weight-bold" :class="`text-${colorirStatus(venda.SITUACAO, venda)}`">{{traduzirSituacao(venda)}}</h5>
            </div>
          </b-col>
          <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-info" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Quant. Prevista</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{Number(totalQuantPedido || 0).toLocaleString('pt-BR', {minimumFractionDigits: 3, maximumFractionDigits: 3})}}</h4>
            </div>
          </b-col>
          <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-primary" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Quant. Embarcada</small>
              <h5 class="mb-0 font-weight-bold text-dark">{{Number(totalQuantEmbarcada || 0).toLocaleString('pt-BR', {minimumFractionDigits: 3, maximumFractionDigits: 3})}}</h5>
            </div>
          </b-col>
          <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-warning" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Volumes / Itens</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{totalPecas || 0}}</h4>
            </div>
          </b-col>
          <b-col md="4">
            <div class="stat-item bg-gradient-primary p-3 rounded shadow text-center transition-hover h-100 d-flex flex-column justify-content-center border-0">
              <small class="modal-label-premium d-block text-white opacity-75">VALOR TOTAL DO PEDIDO</small>
              <h2 class="mb-0 font-weight-bold text-white">{{Number(totalVenda || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h2>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col sm="7">
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-user-circle mr-2'></i>Identificação
                </h5>
              </div> 
              <b-card-body class="pt-0">
                <b-row>
                  <!--/.col-->
                  <b-col sm="3">
                    <b-form-group label="Pedido ID" label-class="modal-label-premium">
                      <b-form-input 
                        type="text" 
                        id="ID" 
                        :disabled="true" 
                        class="rounded-pill bg-light border-0 shadow-xs"
                        placeholder="Código Automático" 
                        v-model="venda.SEQUENCIA">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <!--/.col-->
                  <b-col sm="4">
                    <b-form-group label="Data do Pedido" label-class="modal-label-premium">
                      <b-form-input  type="date" 
                                      id="edDT_PEDIDO" 
                                      v-model="venda.DT_PEDIDO"
                                      :disabled="controles.fechada"
                                      class="rounded-pill shadow-xs"
                                      :class="{'is-invalid': !venda.DT_PEDIDO }"  
                                      placeholder="Informe Data do Pedido" > 
                        </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group label="Tipo de Contato" label-class="modal-label-premium">
                      <b-form-select :plain="true" 
                                    v-model="venda.PAG2"
                                    class="rounded-pill shadow-xs"
                                    :disabled="controles.fechada"
                                    :options="tipoContatoOptions">
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="1">
                    <b-form-group label="Entrega" label-class="modal-label-premium">
                      <vue-autonumeric  v-model="venda.NENTREGA" 
                        :disabled="controles.fechada"
                        class="form-control rounded-pill shadow-xs text-right"
                        :options="{
                              digitGroupSeparator: '.',
                              decimalCharacter: ',',
                              decimalCharacterAlternative: '.',
                              decimalPlaces: '0',
                              roundingMethod: 'U',
                              minimumValue: '0'
                        }">
                      </vue-autonumeric>
                    </b-form-group>
                  </b-col>
                </b-row>  
                <b-row>  
                  <b-col sm="12">
                    <cliente-pesquisa 
                                    @retornaId="venda.COD_CLI = $event"
                                    :idInicial="venda.COD_CLI"
                                    :classe-required="true"
                                    :desabilitarInput="controles.fechada"
                                    idModal="modalCliente"
                                    :labelVermelho="controles.clienteBloqueado"
                                    :label="controles.situacaoCliente"
                                    :exibirBloqueado="controles.clienteBloqueado"
                                    id="edCOD_CLI"
                                    ref="edCOD_CLI"
                                    place="Informe o Cliente"
                                    :arredondado="true"
                                    labelBotao="">
                    </cliente-pesquisa>
                  </b-col>
                </b-row>  
                <b-row>  
                  <b-col sm="12" class="mt-2">
                    <b-form-group label="Vendedor" label-class="modal-label-premium">
                      <vendedor-dropdown
                        v-model="venda.COD_VENDEDOR"
                        :disabled="controles.fechada"
                        input-class="rounded-pill shadow-xs"
                        :placeholder="'Pesquise pelo nome do vendedor...'"
                        :state="!!venda.COD_VENDEDOR"
                      />
                    </b-form-group>
                  </b-col>  
                </b-row>
                <b-row class="mt-2">
                  <b-col sm="4">
                    <b-form-group label="Limite de Crédito" label-class="modal-label-premium">
                      <vue-autonumeric  v-model="limiteCredito" 
                                                :disabled="true"
                                                class="form-control rounded-pill bg-light border-0 shadow-xs text-right"
                                                :options="{
                                                      digitGroupSeparator: '.',
                                                    decimalCharacter: ',',
                                                    decimalCharacterAlternative: '.',
                                                    roundingMethod: 'U',
                                                    minimumValue: '0'
                                              }">
                            </vue-autonumeric>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group label="Notas Areceber" label-class="modal-label-premium">
                      <b-form-input 
                        type="text" 
                        id="edTitulos" 
                        :disabled="true" 
                        class="rounded-pill bg-light border-0 shadow-xs"
                        placeholder="Notas" 
                        v-model="cliente.NOTAS_EM_ABERTO">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group label="ICMS" label-class="modal-label-premium">
                      <b-form-input 
                        type="text" 
                        id="edICMS" 
                        :disabled="true" 
                        class="rounded-pill bg-light border-0 shadow-xs"
                        placeholder="Imposto" 
                        v-model="textoImposto">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  
                  
                </b-row>
              </b-card-body>
            </b-card>  
          </b-col>
          <b-col sm="5">
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-credit-card mr-2'></i>Condições de Pagamento
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-row>
                  <!--/.col-->
                  <b-col sm="7">
                    <b-form-group label="Forma de pagamento" label-class="modal-label-premium">
                      <b-form-select :plain="true" 
                                    :disabled="controles.fechada" 
                                    v-model="venda.OP_FORMA_PAGTO"
                                    class="rounded-pill shadow-xs"
                                    :state="venda.OP_FORMA_PAGTO != null"  
                                    :options="tipoPagamento">
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <!--/.col-->
                  <b-col sm="4" v-if="venda.OP_FORMA_PAGTO === 'P' ">
                    <b-form-group label="A partir de" label-class="modal-label-premium">
                      <b-form-input   type="date" 
                                      id="ed_dtInicarPagamento" 
                                      :disabled="controles.fechada"  
                                      class="rounded-pill shadow-xs"
                                      v-model="venda.DT_INICIAR_PAGAMENTO" 
                                      :state="venda.DT_INICIAR_PAGAMENTO != null"  
                                      placeholder="" > 
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <!--/.col-->
                  <b-col sm="2" v-if="venda.OP_FORMA_PAGTO === 'P' ">
                    <b-form-group label="Dias" label-class="modal-label-premium">
                      <vue-autonumeric  
                          v-model="diasIniciarPagamento" 
                          :disabled="controles.fechada"  
                          class="form-control rounded-pill shadow-xs text-right"
                          :options="{
                                digitGroupSeparator: '.',
                                decimalCharacter: ',',
                                decimalCharacterAlternative: '.',
                                decimalPlaces: '0',
                                roundingMethod: 'U',
                                minimumValue: '0'
                          }"
                          :class="{
                                      'autonumeric_required': diasIniciarPagamento == null,
                                      'autonumeric_is-valid': diasIniciarPagamento != null
                                    }">
                        </vue-autonumeric>
                    </b-form-group>
                  </b-col>
                  <!--/.col-->
                  <b-col sm="3" v-if="venda.OP_FORMA_PAGTO === 'P' ">
                    <b-form-group label="Vezes" label-class="modal-label-premium">
                      <b-form-select 
                                    v-model="venda.NR_PARCELAS"
                                    class="rounded-pill shadow-xs"
                                    :disabled="controles.fechada" 
                                    :state="venda.NR_PARCELAS != null"  
                                    :options="parcelasVezes">
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  
                  
                  <!--/.col-->
                  <b-col sm="3" v-if="venda.OP_FORMA_PAGTO === 'P' ">
                        <b-overlay :show="controles.botaoGerarDocumento.busy" rounded="lg" opacity="0.6" @hidden="onHidden_botaoGerarDocumento()">
                            <template #overlay>
                              <div class="d-flex align-items-center">
                                <b-spinner small type="grow" variant="secondary"></b-spinner>
                                <b-spinner type="grow" variant="dark"></b-spinner>
                                <b-spinner small type="grow" variant="secondary"></b-spinner>
                                <!-- We add an SR only text for screen readers -->
                                <span class="sr-only">Please wait...</span>
                              </div>
                            </template>
                            <b-form-group
                                id="labelPAG1"
                                label="Dias entre Parcelas"
                                label-class="modal-label-premium"
                                label-for="comboPAG1"
                                valid-feedback="Gerado!"
                              >
                              <b-input-group>
                                  <b-form-select 
                                    id="comboPAG1"
                                    class="rounded-pill shadow-xs"
                                    :disabled="controles.fechada" 
                                    v-model="venda.PAG1"
                                    :state="valPAG1"  
                                    :options="dias">
                                  </b-form-select>
                                  
                              </b-input-group>
                                
                          </b-form-group>
                        </b-overlay>

                  </b-col>
                </b-row>
                <b-row>
                  <!--/.col-->
                  <b-col sm="12" >
                    <b-form-group
                                label="Observações para Expedição"
                                label-class="modal-label-premium"
                                label-for="edOBSERVACOES"
                                valid-feedback=""
                              >
                      <b-form-textarea
                          id="edOBSERVACOES"
                          ref="edOBSERVACOES"
                          class="rounded shadow-xs"
                          :disabled="controles.fechada" 
                          v-model="venda.OBS_PEDIDO"
                          placeholder="Observações"
                          rows="4"
                          max-rows="4">
                      </b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
            <b-row>
              <b-col sm="12">
                <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
                  <div class="card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
                    <h5 class="mb-0 text-primary font-weight-bold">
                      <i class='fa fa-shopping-basket mr-2'></i>Produtos do Pedido
                    </h5>
                    <b-button v-if="habilitaBotaoProdutos"
                              size="md" 
                              ref="btAdicionarItem"
                              variant="success" 
                              pill
                              class="shadow-sm font-weight-bold" 
                              type="button" @click="abrirModalItemNovo()" > 
                          <i class="fa fa-plus mr-1"></i> Adicionar Produto <small>(INSERT)</small>
                      </b-button>
                  </div>
                  <b-card-body class="p-0">
                    <b-table 
                            class="mb-0" 
                            stacked="md"
                            responsive
                            hover 
                            select-mode="single"
                            selectable
                            @row-selected="abrirModalAlterarProduto"
                            :items="tabelaItens.items" 
                            :fields="tabelaItens.fields"
                            head-variant="light">
                      <template #cell(COD_PRO)="row"> 
                          <span class="font-weight-bold text-dark">{{row.item.COD_PRO}}</span>
                      </template>
                      <template #cell(NOME_PRODUTO)="row"> 
                            <span class="text-muted">{{row.item.NOME_PRODUTO}}</span>
                      </template>
                      <template #cell(OP_REPESAR)="row"> 
                        <div  v-if="!controles.fechada">
                          <label class="switch switch-sm switch-text switch-info  mb-0">
                          <input type="checkbox" class="switch-input" v-model="row.item.OP_REPESAR">
                          <span class="switch-label" data-on="REP" data-off="ETQ"></span>
                          <span class="switch-handle"></span>
                        </label>
                        </div >
                          
                        <div v-else>
                          <b-badge :variant="row.item.OP_REPESAR ? 'danger' : 'info'" pill>
                            {{ row.item.OP_REPESAR ? 'SIM' : 'NÃO' }}
                          </b-badge>
                        </div>
                      </template>
                      <template #cell(actions)="linha">
                        <b-button v-if="!controles.fechada" size="sm" variant="soft-danger" pill class="btn-icon" @click.stop.prevent="abrirModalExcluirItem(linha.item)" >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </template> 
                    </b-table>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
                
      

      <!--/.row-->
    
    </div>
     
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ITENS - PEDIDO WEB
            ----------------------------------------------------------------------------------- -->
    <div>
        <b-modal ref="modal-item" 
            id="modal-item" 
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            hide-header
            hide-footer
            centered 
            body-class="p-0"
            content-class="border-0 shadow-lg"
            size="lg"
            @shown="focusModalItem()"
            @hidden="limparCriticaEstoqueModalItem()" >

            <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
                <div class="header-icon-wrapper-modal mr-3 bg-white-20 rounded-circle p-2 d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                    <i class="fa fa-shopping-cart text-white fa-lg"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Detalhes do Produto</h5>
                    <small class="text-white opacity-75">ADICIONE OU EDITE ITENS DO PEDIDO</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs['modal-item'].hide()">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
            </div>

            <b-card no-body class="border-0 rounded-0">
                
                <b-card-body class="p-4">
                  <div v-if="estoqueCriticaModalItem.visivel" class="stock-banner-modal mb-4">
                    <div class="stock-banner-title">Saldo atualizado durante a edicao</div>
                    <div class="stock-banner-message">{{ estoqueCriticaModalItem.mensagem }}</div>
                    <div
                      v-for="itemCritica in estoqueCriticaModalItem.itens"
                      :key="`critica-estoque-web-${itemCritica.PRODUTO_ID}`"
                      class="stock-banner-item">
                      {{ itemCritica.DESCRICAO_PRODUTO }}: solicitado {{ itemCritica.PECAS_PEDIDO_SOLICITADO }}, disponivel agora {{ itemCritica.PECAS_DISPONIVEIS_ATUAL }}, ajustado para {{ itemCritica.PECAS_PEDIDO_AJUSTADO }}.
                    </div>
                  </div>
                  <b-row>
                      <b-col sm="4">
                        <div class="stat-item bg-light p-4 rounded-lg text-center mb-3 border-0 shadow-xs">
                          <div class="h1 text-muted mb-3">
                            <i class="fa fa-barcode"></i>
                          </div>
                          <h4 class="mb-1 font-weight-bold text-primary">{{item.EAN || '---'}}</h4>
                          <small class="text-muted text-uppercase font-weight-bold small">Código de Barras</small>
                          
                          <hr class="my-3">
                          
                          <h4 class="mb-1 font-weight-bold text-primary">{{item.TX_NCM || 'Não Informado'}}</h4>
                          <small class="text-muted text-uppercase font-weight-bold small">NCM</small>
                        </div>
                      </b-col>
                      <b-col sm="8">
                        <b-row>
                          <!--/.col-->
                          <b-col sm="12">
                            <b-form-group label="Produto" label-class="modal-label-premium">
                              <produto-pesquisa-estoque 
                                                @retornaId="item.COD_PRO = $event"
                                                :idInicial="item.COD_PRO"
                                                :desabilitarInput="controles.itemAlteracao"
                                                :classe-required="!valCOD_PRO"
                                                :vendaPorPecas="controles.vendaPorPecas"
                                                id="edCOD_PRO"
                                                ref="edCOD_PRO"
                                                :arredondado="true"
                                                place="Informe o Produto"
                                                labelBotao="">
                              </produto-pesquisa-estoque>
                            </b-form-group>
                          </b-col>
                        </b-row>  
                        <b-row>  
                          <!--/.col-->
                          <b-col sm="6">
                            <b-form-group :label="controles.vendaPorPecas ? 'Estoque Disponível (Vol)' : 'Estoque Disponível (Peso/UND)'" label-class="modal-label-premium">
                              <b-form-input 
                                class="text-right rounded-pill bg-light border-0 shadow-xs"
                                type="text" 
                                :disabled="true" 
                                placeholder="Estoque" 
                                :value="controles.vendaPorPecas ? estoqueProduto.PECAS : (estoqueProduto.QUANT ? estoqueProduto.QUANT.toLocaleString('pt-BR', {minimumFractionDigits: 3}) : '0,000')">
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col sm="6">
                            <b-form-group :label="controles.vendaPorPecas ? 'Peças' : 'Quantidade'" label-class="modal-label-premium">
                              <vue-autonumeric  v-model="item.PECAS_PEDIDO" 
                                                ref="edPECAS_PEDIDO"
                                                class="form-control rounded-pill shadow-xs text-right"
                                                :options="{
                                                      digitGroupSeparator: '.',
                                                      decimalCharacter: ',',
                                                      decimalCharacterAlternative: '.',
                                                      decimalPlaces: controles.vendaPorPecas ? '0' : '3',
                                                      roundingMethod: 'U',
                                                      minimumValue: '0'
                                                }"
                                                :class="{
                                                          'autonumeric_required' : !valPECAS_PEDIDO,
                                                          'autonumeric_is-valid': valPECAS_PEDIDO
                                                        }">
                              </vue-autonumeric>
                            </b-form-group>
                          </b-col>
                          
                        </b-row>
                        <b-row>  
                          <b-col sm="6">
                          </b-col>
                          <!--/.col-->
                          <b-col sm="6">
                            <b-form-group
                                  id="lbPreco"
                                  :description=" precoTabelado ? 'PRODUTO COM PREÇO TABELADO' : 'ÚLTIMO PREÇO VENDIDO'"
                                  label="Preço de Venda R$"
                                  label-class="modal-label-premium"
                                  label-for="edPreco"
                                  valid-feedback="Adicionado!">

                              <vue-autonumeric   v-if="!precoTabelado"
                                                v-model="item.VL_UNT" 
                                                class="form-control rounded-pill shadow-xs text-right"
                                                :options="{
                                                      digitGroupSeparator: '.',
                                                      decimalCharacter: ',',
                                                      decimalCharacterAlternative: '.',
                                                      roundingMethod: 'U',
                                                      minimumValue: '0'
                                                }"
                                                :class="{
                                                        'autonumeric_required' : !valVL_UNT,
                                                        'autonumeric_is-valid': valVL_UNT
                                                        }">
                              </vue-autonumeric>
                            </b-form-group>   
                            
                          </b-col>
                        </b-row>
                      </b-col>  
                  </b-row>
                </b-card-body>

                <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
                    <b-button v-if="controles.itemAlteracao" variant="success" pill class="px-4 shadow-sm font-weight-bold mr-2" @click="editItem()">
                        <i class="fa fa-save mr-1"></i> GRAVAR ALTERAÇÃO
                    </b-button>
                    <b-button v-else variant="success" pill class="px-4 shadow-sm font-weight-bold mr-2" @click="postItem()">
                        <i class="fa fa-plus mr-1"></i> GRAVAR ITEM
                    </b-button>
                    <b-button variant="outline-danger" pill class="px-4 font-weight-bold border-0" @click="$refs['modal-item'].hide()">
                        CANCELAR
                    </b-button>
                </div>
            </b-card>
        </b-modal>
    </div>
    
    
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ALTERAR ITEM 
    ----------------------------------------------------------------------------------- -->
    <div>
      
      <b-modal ref="modal-alterar-item" 
          id="modal-alterar-item" 
          hide-header
          body-class="p-0"
          size="lg"
          centered
          headerClass= "p-2 border-bottom-0" 
          title="ALTERAR ITEM DO PEDIDO" >
        <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                    no-wrap 
                    fixed 
                    z-index="1100" 
                    spinner-variant="primary"
                    spinner-type="border">
          <template #overlay>
            <div class="text-center">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p>Por favor. Aguarde!!!...</p>
            </div>
          </template>
        </b-overlay>
        <b-card no-body class="border-0 shadow-sm rounded-lg overflow-hidden">
            <div class="modal-header-premium bg-gradient-primary text-white p-3">
                <h5 class="mb-0 font-weight-bold">
                  <i class='fa fa-edit mr-2'></i>Alterar o Item do Pedido
                </h5>
            </div>
            
            <b-card-body class="p-4">
              <b-row class="mb-3">
                <b-col>
                  <h5 class="text-primary font-weight-bold mb-0">{{itemAlteracao.CODIGO_NOME_PRODUTO}}</h5>
                </b-col>
              </b-row>

              <b-row class="mb-4">
                <b-col md="6">
                  <div class="stat-item bg-light p-3 rounded shadow-xs border-0 h-100">
                    <span class="modal-label-premium text-muted d-block">Preço Unitário</span>
                    <h4 class="mb-0 font-weight-bold text-dark">{{itemAlteracao.VL_UNT_MASK}}</h4>
                  </div>
                </b-col>
                <b-col md="6">
                  <div class="stat-item bg-light p-3 rounded shadow-xs border-0 h-100">
                    <span class="modal-label-premium text-muted d-block">{{ controles.vendaPorPecas ? 'Estoque Disponível (Vol)' : 'Estoque Disponível (Peso/UND)' }}</span>
                    <h4 class="mb-0 font-weight-bold text-info">{{itemAlteracao.PECAS_ESTOQUE}}</h4>
                  </div>
                </b-col>
              </b-row>

              <b-row align-v="center">
                <b-col sm="4">
                  <label class="modal-label-premium mb-0">{{ controles.vendaPorPecas ? 'Quantidade no Pedido (Vol):' : 'Quantidade no Pedido:' }}</label>
                </b-col>
                <b-col sm="8">
                  <b-input-group class="cec-pill-group shadow-xs">
                    <b-input-group-prepend class="cec-pill-append">
                      <b-button   
                            variant="outline-danger"  
                            class="cec-pill-left px-3"
                            @touchstart="handleMouseDownDecrementarItemAlteracao()"
                            @touchend="handleMouseUpDecrementarItemAlteracao ()"
                            @touchcancel="handleMouseLeaveDecrementarItemAlteracao()"
                            @contextmenu.prevent   >  
                          <i class="fa fa-minus"></i>
                      </b-button>
                    </b-input-group-prepend>
                    
                    <vue-autonumeric  v-model="itemAlteracao.PECAS_PEDIDO" 
                                      :disabled="true"
                                      class="form-control text-center font-weight-bold"
                                      :options="{
                                            digitGroupSeparator: '.',
                                            decimalCharacter: ',',
                                            decimalCharacterAlternative: '.',
                                            decimalPlaces: controles.vendaPorPecas ? '0' : '3',
                                            roundingMethod: 'U',
                                            minimumValue: '0',
                                            maximumValue: itemAlteracao.PECAS_ESTOQUE.toString()
                                      }"
                                      :class="{'bg-warning-soft text-warning': itemAlteracao.PECAS_PEDIDO > 0}">
                    </vue-autonumeric>

                    <b-input-group-append class="cec-pill-append">
                      <b-button 
                                variant="outline-success" 
                                class="cec-pill-right px-3"
                                @touchstart="handleMouseDownAcrescentarItemAlteracao()"
                                @touchend="handleMouseUpAcrescentarItemAlteracao ()"
                                @touchcancel="handleMouseLeaveAcrescentarItemAlteracao()"
                                @contextmenu.prevent  > 
                          <i class="fa fa-plus"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-card-body>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="success" pill class="px-4 shadow-sm font-weight-bold" @click="editItem()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>
          <b-button variant="light" pill class="px-4 shadow-sm font-weight-bold" @click="cancel()">
            FECHAR
          </b-button>
        </template>
      </b-modal>
  </div>

    
    <!--  -----------------------------------------------------------------------------------
                                          MODAL EXCLUIR ITEM 
            ----------------------------------------------------------------------------------- -->
    <div>
      
        <b-modal ref="modal-excluir-item" 
            id="modal-excluir-item" 
            hide-header
            body-class="p-0"
            size="lg"
            centered
            headerClass= "p-2 border-bottom-0" 
            title="REMOVER ITEM DO PEDIDO" >
          <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                      no-wrap 
                      fixed 
                      z-index="1100" 
                      spinner-variant="primary"
                      spinner-type="border">
            <template #overlay>
              <div class="text-center">
                <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                <p>Por favor. Aguarde!!!...</p>
              </div>
            </template>
          </b-overlay>
          <b-card no-body class="border-0 shadow-sm rounded-lg overflow-hidden">
              <div class="modal-header-premium bg-gradient-danger text-white p-3">
                  <h5 class="mb-0 font-weight-bold">
                    <i class='fa fa-trash mr-2'></i>Remover o Item do Pedido
                  </h5>
              </div>
              
              <b-card-body class="p-4">
                <b-row class="mb-3">
                  <b-col>
                    <h5 class="text-danger font-weight-bold mb-0">{{itemExcluir.CODIGO_NOME_PRODUTO}}</h5>
                  </b-col>
                </b-row>

                <div class="bg-light p-3 rounded shadow-xs border-0">
                  <b-row class="mb-2" align-v="center">
                    <b-col sm="4">
                      <span class="modal-label-premium text-muted">Quantidade:</span>
                    </b-col>
                    <b-col sm="8" class="text-right">
                      <h5 class="mb-0 font-weight-bold text-dark">{{itemExcluir.QUANT_MASK}}</h5>
                    </b-col>
                  </b-row>  
                  <b-row class="mb-2" align-v="center">
                    <b-col sm="4">
                      <span class="modal-label-premium text-muted">Peças:</span>
                    </b-col>
                    <b-col sm="8" class="text-right">
                      <h5 class="mb-0 font-weight-bold text-success">{{itemExcluir.PECAS_PEDIDO}}</h5>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" align-v="center">
                    <b-col sm="4">
                      <span class="modal-label-premium text-muted">Embarcados:</span>
                    </b-col>
                    <b-col sm="8" class="text-right">
                      <h5 class="mb-0 font-weight-bold text-danger">{{itemExcluir.PECAS}}</h5>
                    </b-col>
                  </b-row>
                  <b-row align-v="center">
                    <b-col sm="4">
                      <span class="modal-label-premium text-muted">Preço:</span>
                    </b-col>
                    <b-col sm="8" class="text-right">
                      <h5 class="mb-0 font-weight-bold text-primary">{{itemExcluir.VL_UNT? itemExcluir.VL_UNT.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : ''}}</h5>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
          </b-card>

          <template #modal-footer="{ cancel }">
            <b-button variant="danger" pill class="px-4 shadow-sm font-weight-bold" @click="deleteItem()">
              <i class="fa fa-trash mr-1"></i> REMOVER ITEM
            </b-button>
            <b-button variant="light" pill class="px-4 shadow-sm font-weight-bold" @click="cancel()">
              FECHAR
            </b-button>
          </template>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL REABRIR VENDA 
            ----------------------------------------------------------------------------------- -->
    <div>
      
        <b-modal ref="modal-reabrir" 
            id="modal-reabrir" 
            hide-header
            body-class="p-0"
            size="lg"
            centered
            headerClass= "p-2 border-bottom-0" 
            title="REABRIR PEDIDO" >
          
          <b-card no-body class="border-0 shadow-sm rounded-lg overflow-hidden">
              <div class="modal-header-premium bg-gradient-warning text-white p-3">
                  <h5 class="mb-0 font-weight-bold">
                    <i class='fa fa-unlock mr-2'></i>Reabrir o Pedido
                  </h5>
              </div>
              <b-card-body class="p-4">
                 <b-row class="mb-3">
                  <b-col>
                    <div class="d-flex align-items-center mb-2">
                      <b-badge variant="warning" pill class="px-3 py-2 mr-3 text-white">
                        <h5 class="mb-0 font-weight-bold">PEDIDO: {{venda.N_VENDA}}</h5>
                      </b-badge>
                      <h5 class="mb-0 text-dark font-weight-bold">{{cliente.CODIGO}} - {{cliente.RAZAOSOCIAL}}</h5>
                    </div>
                  </b-col>
                </b-row>
                
                <div class="stat-item bg-light p-3 rounded shadow-xs mb-4 border-left border-warning" style="border-left-width: 4px !important;">
                  <b-row align-v="center">  
                    <b-col cols="12" md="4">
                      <span class="modal-label-premium text-muted d-block">Valor da Venda</span>
                    </b-col>
                    <b-col cols="12" md="8">
                      <h3 class="mb-0 font-weight-bold text-warning">{{totalVenda.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h3>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
          </b-card>

          <template #modal-footer="{ cancel }">
            <b-button variant="warning" pill class="px-4 shadow-sm font-weight-bold text-white" @click="reabrir()">
              <i class="fa fa-unlock mr-1"></i> REABRIR
            </b-button>
            <b-button variant="light" pill class="px-4 shadow-sm font-weight-bold" @click="cancel()">
              FECHAR
            </b-button>
          </template>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL CANCELAR
            ----------------------------------------------------------------------------------- -->
    <div>
      
      <b-modal ref="modal-cancelar" 
          id="modal-Cancelar" 
          hide-header
          body-class="p-0"
          size="lg"
          centered
          headerClass= "p-2 border-bottom-0" 
          title="CANCELAR PEDIDO" >
        
        <b-card no-body class="border-0 shadow-sm rounded-lg overflow-hidden">
            <div class="modal-header-premium bg-gradient-danger text-white p-3">
                <h5 class="mb-0 font-weight-bold">
                  <i class='fa fa-times-circle mr-2'></i>Cancelar o Pedido
                </h5>
            </div>
            <b-card-body class="p-4">
               <b-row class="mb-3">
                <b-col>
                  <div class="d-flex align-items-center mb-2">
                    <b-badge variant="danger" pill class="px-3 py-2 mr-3">
                      <h5 class="mb-0 font-weight-bold">PEDIDO: {{venda.N_VENDA}}</h5>
                    </b-badge>
                    <h5 class="mb-0 text-dark font-weight-bold">{{cliente.CODIGO}} - {{cliente.RAZAOSOCIAL}}</h5>
                  </div>
                </b-col>
              </b-row>
              
              <div class="stat-item bg-light p-3 rounded shadow-xs mb-4 border-left border-danger" style="border-left-width: 4px !important;">
                <b-row align-v="center">  
                  <b-col cols="12" md="4">
                    <span class="modal-label-premium text-muted d-block">Valor da Venda</span>
                  </b-col>
                  <b-col cols="12" md="8">
                    <h3 class="mb-0 font-weight-bold text-danger">{{totalVenda.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h3>
                  </b-col>
                </b-row>
              </div>
            </b-card-body>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="danger" pill class="px-4 shadow-sm font-weight-bold" @click="cancelar()">
            <i class="fa fa-check mr-1"></i> CONFIRMAR CANCELAMENTO
          </b-button>
          <b-button variant="light" pill class="px-4 shadow-sm font-weight-bold" @click="cancel()">
            FECHAR
          </b-button>
        </template>
      </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import VendedorPesquisa from '../../pesquisa/VendedorPesquisa.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import FuncionarioPesquisa from '../../pesquisa/FuncionarioPesquisa.vue'
import ProdutoPesquisa from '../../pesquisa/ProdutoPesquisa.vue'
import ProdutoPesquisaEstoque from '../../pesquisa/ProdutoPesquisaEstoque.vue'
import VueAutonumeric from 'vue-autonumeric'
import VendedorDropdown from '../../componentes/dropdown/VendedorDropdown.vue'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import moment from 'moment'
import Tools from '@/tools/tools.js'
import { imprimirPedidoEstimado } from './PedidoEstimadoHTML'

export default {
  components: {
    VendedorPesquisa,
    ClientePesquisa,
    FuncionarioPesquisa,
    ProdutoPesquisa,
    ProdutoPesquisaEstoque,
    VueAutonumeric,
    VendedorDropdown,
    HeaderPadrao
  },
  data () {
    return {
      timerBotao: null,
      intervaloBotao: null,
      isProcessoLongo: false,
      testando: true,
      tabIndex: 0,
      precoTabelado: false,
      vendaIdEditar: null,
      vlTotalAntes: 0.00,
      diasIniciarPagamento: null,
      
      tipoMovimentacoes : {
        selected: null,
        options: null
      },
      controles: {
        atualizandoDias: false,
        atualizandoData: false,
        vendaAlteracao: false,
        fechada: false,
        itemAlteracao: false,
        situacaoCliente : 'Cliente',
        classeLabelVermelhoCliente : false,
        clienteBloqueado : false,
        OP_ICMS_SITUACAO_TRIBUTARIA: null,
        expedicaoDireta: false,
        expedicaoConferencia: false,
        COD_PRO: null,
        vendaPorPecas: false,
        campoGerarDocumento: {
          desabilitado: false
        },
        botaoGerarDocumento: {
          value: 'Some value',
          busy: false,
          clicou: false
        }
      },
      cliente: {
        CODIGO: null,
        NOME: null,
        RAZAOSOCIAL: null,
        ID_UF: null,
        FIZ_JUR: null,
        ISENTO_ICMS: null,
        COD_VEND: null,
        VL_CREDITO: 0.00,
        LIMITE_CREDITO: 0.00,
        NOTAS_EM_ABERT0: 0,
        PRAZO: null,
        TIPO_CLI: null,
        GRUPO_ARECEBER_ID: null
      },
      venda: {
        SEQUENCIA                 : null,
        N_VENDA                   : null,
        DT_SAIDA                  : null,
        COD_CLI                   : null,
        OP_PEDIDO                 : null,
        USUARIO_PEDIDO            : null, 
        TIPO_MOVIMENTACAO_ID      : null,  
        DT_PAG                    : null,
        PAG1                      : null,
        PAG2                      : null,
        PAG3                      : null,
        PAG4                      : null,
        PAG5                      : null,
        TIPO                      : null,
        TIPO_VEN                  : null,
        FORMA                     : null,
        COD_VENDEDOR              : null,
        COD_MOTORISTA             : null,
        VL_TOTAL                  : null,
        OBS2                      : null,
        OBS3                      : null,
        LOTE                      : null,
        TIPO_DOCPAG               : null,
        N_DOCPAG                  : null,
        COD_REPRES                : null,
        COD_CONFERENTE            : null,
        TIPO_VENDEDOR             : null,
        ITENS                     : null,
        NENTREGA                  : null,
        PLACA                     : null,
        VL_ENTRADA                : null,
        VL_DESCONTO               : null,
        CFOP                      : null,
        UFENT                     : null,
        TELENT                    : null,
        CONTATOENT                : null,
        BAIRROENT                 : null,
        CIDADEENT                 : null,
        ENDENT                    : null,
        USUARIO                   : null,
        MOT_CANC                  : null,
        NUMNF                     : null,
        SERIENF                   : null,
        UFPLACA                   : null,
        PORCONTA                  : null,
        VOLUMES                   : null,
        PESOLIQUIDO               : null,
        PESOBRUTO                 : null,
        TOTALNF                   : null,
        DT_CANC                   : null,
        DT_ALTERACAO              : null,
        TX_USUARIO_ALTERACAO      : null,
        VL_TOTAL_ANTES_ALTERACAO  : null,
        VL_BASE_CALC_ICMS         : 0.00,
        VL_TOTAL_ICMS             : 0.00,
        VL_BASE_CALC_ST_ICMS      : 0.00,
        VL_TOTAL_ST_ICMS          : 0.00,
        VL_TOTAL_IPI              : 0.00,
        VL_TOTAL_PIS              : 0.00,
        VL_TOTAL_COFINS           : 0.00,
        VL_TOTAL_DESCONTO         : 0.00,
        VL_TOTAL_SEGURO           : 0.00,
        VL_TOTAL_OUTRAS_DESP      : 0.00,
        VL_TOTAL_FRETE            : 0.00,
        NR_PESO_BRUTO             : 0.00,
        VL_TOTAL_PRODUTOS         : 0.00,
        NR_PESO_LIQUIDO           : 0.00,
        VL_TOTAL_NFE              : 0.00,
        QUANT_PEDIDO              : 0.00,
        VL_TOTAL_PREVISTO         : 0.00,
        OP_FORMA_PAGTO            : null,
        TX_USUARIO_CANCELAMENTO   : null,
        NR_PARCELAS               : null,
        COD_TRANSP                : null,
        ORIGEM                    : null,
        DT_PREVISAO_ENTREGA       : null,
        HORA                      : null,
        DT_PEDIDO                 : Tools.getDataAtual(),
        DT_SISTEMA_CANCELAMENTO   : null,
        DT_CADASTRO_SISTEMA       : null,
        DT_ALTERACAO_SISTEMA      : null,
        OBSERVACOES               : null,
        SITUACAO                  : null,
        DT_RETORNO                : null,
        NOME_RESPONSAVEL_RETORNO  : null,
        DT_LANCAMENTO_RETORNO     : null,
        OBS_RETORNO               : null,
        USUARIO_RETORNO           : null,
        VL_TOTAL_RETORNO_BKP      : 0.00,
        VL_TOTAL_RETORNO          : 0.00,
        DT_LANCAMENTO_WEB         : null,
        OP_LANCAMENTO_WEB         : null,
        USUARIO_LANCAMENTO_WEB    : null,
        OBS_PEDIDO                : null,
        DT_INICIAR_PAGAMENTO      : null,
        OP_CONFERENCIA_VENDA      : '0',

      },
      itemAlteracao: {
        CONTROLE: null,
        COD_PRO: null,
        CODIGO_NOME_PRODUTO: '',
        PECAS_ESTOQUE: 0,
        PECAS_PEDIDO: 0,
        TX_UNIDADE_COMERCIAL: '',
        VL_UNT: 0.00,
        VL_UNT_MASK: 0.00
      },
      tabelaPreco:{
        selected: null,
        options:[]
      },
      itemExcluir: {
        CONTROLE: null,
        COD_PRO: null,
        COD_CENTRO: null,
        CODIGO_NOME_PRODUTO: '',
        QUANT: 0.00,
        PECAS_PEDIDO: 0,
        PECAS: 0,
        TX_UNIDADE_COMERCIAL: '',
        VL_UNT: 0.00,
        VL_DESCONTO: 0.00,
        VL_TOTAL: 0.00
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false
        }
      },
      modalReabrir: {
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false,
          permissao : false
        }
      },
      
      parametros: {},
      item: {
        CONTROLE                       : null, 
        SEQUENCIA                      : null, 
        COD_PRO                        : null, 
        EAN                            : null, 
        QUANT                          : null, 
        VL_UNT                         : null, 
        VL_CUSTO                       : null, 
        UND_PECAS                      : null, 
        PECAS                          : null, 
        DT_VENDA                       : null, 
        TIPO_CLI                       : null, 
        MARCA                          : null, 
        TIPO_VEN                       : null, 
        ALTERA                         : null, 
        ITEM                           : null, 
        VL_COMISSAO                    : null, 
        COD_CENTRO                     : null, 
        ICMS                           : null, 
        IPI                            : null, 
        ISS                            : null, 
        IRRF                           : null, 
        ICMSSUBSTITUI                  : null, 
        FORMA                          : null, 
        ID_CFOP                        : null, 
        OP_STATUS_PRECO                : null, 
        VL_TOTAL_BRUTO                 : 0.00, 
        VL_TOTAL_DESCONTO              : null, 
        OP_ICMS_SITUACAO_TRIBUTARIA    : null, 
        OP_ICMS_ORIGEM                 : null, 
        OP_ICMS_MODAL_DETERM_BC        : null, 
        VL_ICMS_PERCENT_REDUC_BC       : '', 
        VL_ICMS_BASE_CALC              : '', 
        VL_ICMS_ALIQUOTA               : '', 
        VL_ICMS                        : '', 
        OP_ICMS_MODAL_DETERM_BC_ST     : null, 
        VL_ICMS_MARGEM_VL_ADIC_ST      : '', 
        VL_ICMS_PERCENT_REDUC_BC_ST    : '', 
        VL_ICMS_BASE_CALC_ST           : '', 
        VL_ICMS_ALIQUOTA_ST            : '', 
        VL_ICMS_ST                     : '', 
        OP_IPI_SITUACAO_TRIBUTARIA     : null, 
        OP_IPI_CLASS_ENQ_CIG_BEB       : null, 
        TX_IPI_CODIGO_ENQUAD_LEGAL     : null, 
        TX_IPI_CNPJ_PRODUTOR           : null, 
        TX_IPI_NUM_SELO_CONTROLE       : null, 
        OP_IPI_TIPO_CALCULO            : null, 
        VL_IPI_BASE_CALC               : '', 
        VL_IPI_ALIQUOTA                : '', 
        VL_IPI_QUANT_TOTAL_UND_PADRAO  : '', 
        VL_IPI_UNIDADE                 : '', 
        VL_IPI                         : '', 
        OP_PIS_SITUACAO_TRIBUTARIA     : null, 
        OP_PIS_TIPO_CALCULO            : null, 
        VL_PIS_BASE_CALC               : '', 
        VL_PIS_ALIQUOTA_PERCENT        : '', 
        VL_PIS_ALIQUOTA_REAIS          : '', 
        VL_PIS_QUANT_VENDIDA           : '', 
        VL_PIS                         : '', 
        OP_PISST_TIPO_CALCULO          : null, 
        VL_PISST_BASE_CALC             : '', 
        VL_PISST_ALIQUOTA_PERCENT      : '', 
        VL_PISST_ALIQUOTA_REAIS        : '', 
        VL_PISST_QUANT_VENDIDA         : '', 
        VL_PISST                       : '', 
        OP_COFINS_SITUACAO_TRIBUTARIA  : null, 
        OP_COFINS_TIPO_CALCULO         : null, 
        VL_COFINS_BASE_CALC            : '', 
        VL_COFINS_ALIQUOTA_PERCENT     : '', 
        VL_COFINS_ALIQUOTA_REAIS       : '', 
        VL_COFINS_QUANT_VENDIDA        : '', 
        VL_COFINS                      : '', 
        OP_COFINSST_TIPO_CALCULO       : null, 
        VL_COFINSST_BASE_CALC          : '', 
        VL_COFINSST_ALIQUOTA_PERCENT   : '', 
        VL_COFINSST_ALIQUOTA_REAIS     : '', 
        VL_COFINSST_QUANT_VENDIDA      : '', 
        VL_COFINSST                    : '', 
        TX_OBSERVACOES                 : null, 
        OP_COMPOE_VALOR_NFE            : null, 
        VL_ICMS_BC_ST_RETIDO_ANT       : '', 
        VL_ICMS_ST_RETIDO_ANT          : '', 
        VL_ICMS_PERC_BC_OPER_PROPRIA   : '', 
        ID_UF_ICMS_ST                  : null, 
        OP_MOTIVO_DESONERACAO          : null, 
        VL_ALIQ_APLICAVEL_CALC_CREDITO : '', 
        VL_CREDITO_ICMS_APROVEITADO    : '', 
        VL_DESCONTO_PERC               : '', 
        TX_NCM                         : null, 
        TX_NOME_PRODUTO                : null, 
        TX_UNIDADE_COMERCIAL           : null, 
        OP_OCORRENCIA_PRECO            : null, 
        VL_DESCONTO                    : null, 
        ID_UNIDADE_COMERCIAL           : null, 
        OP_TRIBUTACAO                  : null, 
        CEST                           : null, 
        QUANT_BKP                      : null, 
        QUANT_RETORNO                  : null, 
        PECAS_BKP                      : null, 
        PECAS_RETORNO                  : null, 
        PECAS_PEDIDO                   : null,
        OBS_RETORNO                    : null,
        OP_REPESAR                     : null, 
        VL_ICMS_ALIQUOTA_DESONERA      : null,
        VL_ICMS_DESONERA               : null,
        OP_IND_DEDUZ_DESONERA          : null
      },
      tipoVenda: [
        { value: 'VENDA', text: '1 - Romaneio de Vendas' },
        { value: 'PEDIDO', text: '2 - Pedido de Vendas' },
        { value: 'TROCA', text: '3 - Troca de Mercadoria' },
      ],
      tipoPagamento: [
        { value: 'V', text: 'A VISTA' },
        { value: 'P', text: 'A PRAZO'}
      ],
      tipoContatoOptions: [
        { value: '0', text: 'Telefone' },
        { value: '1', text: 'Visita' },
        { value: '2', text: 'Internet' },
      ],
      parcelasVezes: [],
      dias:[],
      produtos: {
        currentPage: 1,
        perPage: 20,
        totalRows: 1,
        items: [],
        campos: [
          {
            key: "ID_PRODUTO",
            label: ' ',
            thStyle: { width: '15% !important'}  
          },
          {
            key: 'QUANTIDADE', 
            label: ' ',
            thStyle: { width: '45% !important '},
            class: 'm-0 p-0 text-right'
          },
          {
            key: "PRECO",
            label: ' ',
            thStyle: { width: '35% !important'},  
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : null
          }
        ]
      },
      estoqueProduto: {
        options: [],
        QUANT: 0.00,
        PECAS: 0,
      },
      estoqueCriticaModalItem: {
        visivel: false,
        mensagem: '',
        itens: []
      },
      tabelaItens: {
        fields: [
          {
            key: "COD_PRO",
            label: 'Produto Id',
            thStyle: { width: '8% !important'}  ,
            class:'text-right', 
          },
          {
            key: "NOME_PRODUTO" ,
            label: 'Descrição' ,
            thStyle: { width: '35% !important'}  ,
            thClass:  'text-left'  
          },
          {
            key: "TX_UNIDADE_COMERCIAL" ,
            label: 'UND' ,
            thStyle: { width: '7% !important'}  ,
            thClass:  'text-center'  ,
            class:'text-center',
          },
          {
            key: "PECAS_PEDIDO" ,
            label: 'Vol. Pedido' ,
            thStyle: { width: '8% !important'}  ,
            thClass:  'text-right'  ,
            class:'text-right', 
          },
          {
            key: "PECAS" ,
            label: 'Vol. Embarcado' ,
            thStyle: { width: '8% !important'}  ,
            thClass:  'text-right'  ,
            class:'text-right', 
          },
          {
            key: "QUANT_PEDIDO" ,
            label: 'Quant. Previsto' ,
            thStyle: { width: '10% !important'}  ,
            thClass:  'text-right'  ,
            class:'text-right',
            formatter: (value) => 
                Number(value || 0).toLocaleString('pt-BR', {minimumFractionDigits: 3, maximumFractionDigits: 3})
          },
          {
            key: "QUANT" ,
            label: 'Quant. Embarcado' ,
            thStyle: { width: '10% !important'}  ,
            thClass:  'text-right'  ,
            class:'text-right',
            formatter: (value) => 
                Number(value || 0).toLocaleString('pt-BR', {minimumFractionDigits: 3, maximumFractionDigits: 3})
          },
          {
            key: "VL_UNT" ,
            label: 'Preço' ,
            thStyle: { width: '10% !important'}  ,
            thClass:  'text-right' ,
            class:'text-right', 
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : null
          },
          {
            key: "VL_TOTAL_PREVISTO" ,
            label: 'Total Prev.' ,
            thStyle: { width: '10% !important'}  ,
            thClass:  'text-right' ,
            class:'text-right', 
            formatter: (value, key, item) => 
                (value || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: "OP_REPESAR" ,
            label: 'Repesar', 
            class:'text-center', 
            thClass:  'text-center' ,
            thStyle: { width: '7% !important'}  
          },
          {
            key: "actions" ,
            label: 'ACOES' ,
            thStyle: { width: '7% !important'}  
          }
        ],
        items: []
      },
      filter: '',
      filterOn: [],
      ignorados: [],
      produto: {
        id: null,
        quantidade : 0.00,
        pecas : 0,
        valor: 0.00,
        total: 0.00
      },
      modalItem:{
        overlayBaixando: false,
        icms: {
          opTipoSituacaoTributariaSimples: [
            { value : '00', text : 'ICMS 00 -Tributada Integralmente'},
            { value : '10', text : 'ICMS 10 - Tributada com cobrança do ICMS por Substituição Tributária'},
            { value : '20', text : 'ICMS 20 - Com redução na base de cálculo'},
            { value : '30', text : 'ICMS 30 - Isenta ou não tributada com cobrança do ICMS por substituição tributária'},
            { value : '40', text : 'ICMS 40 - Isenta'},
            { value : '41', text : 'ICMS 41 - Não tributada'},
            { value : '50', text : 'ICMS 50 - Suspensão'},
            { value : '51', text : 'ICMS 51 - Diferimento'},
            { value : '60', text : 'ICMS 60 - Cobrado anteriormente por substiruição tributária'},
            { value : '70', text : 'ICMS 70 - Com redução da base de cálculo e cobrança do ICMS por substituição tributária'},
            { value : '90', text : 'ICMS 90 - Outras'},
          ],
          opTipoSituacaoTributariaNormal: [
            { value: '101', text: 'ICMS 101 - Tributada com permissão de crédito'},
            { value: '102', text: 'ICMS 102 - Trib utada sem permissão de crédito'},
            { value: '103', text: 'ICMS 103 - Isenção do ICMS para faixa de receita bruta'},
            { value: '201', text: 'ICMS 201 - Tributada com permissão de crédito e com cobrança do ICMS por ST'},
            { value: '202', text: 'ICMS 202 - Tributada sem permissão de crédito e com cobrança do ICMS por ST'},
            { value: '203', text: 'ICMS 203 - Isenção do ICMS para faixa de receita bruta e com cobrança do ICMS por ST'},
            { value: '300', text: 'ICMS 300 - Imune'},
            { value: '400', text: 'ICMS 400 - Não tributada'},
            { value: '500', text: 'ICMS 500 - ICMS cobrado anteriormente por ST ou por antecipação'},
            { value: '900', text: 'ICMS 900 - Outros'}
          ],
          opOrigemMercadoria: [
            { value: '0', text: 'Nacional'},
            { value: '1', text: 'Extrangeira - Importação Direta'},
            { value: '2', text: 'Extrangeira - Adquirida no Mercado Interno'},
          ],
          opModalidade: [
            { value: '0', text: 'Margem Valor Agregado'},
            { value: '1', text: 'Pauta Valor'},
            { value: '2', text: 'Preço tabelado Max. Valor'},
            { value: '3', text: 'Valor da Operação'},
          ],
          opMotivoDesoneracao: [
            { value: '', text: ''},
            { value: '1', text: 'Taxi'},
            { value: '2', text: 'Deficiente Fisico'},
            { value: '3', text: 'Produto Agropecuário'},
            { value: '4', text: 'Frotista/Locadora'},
            { value: '5', text: 'Diplomata/Consultor'},
            { value: '9', text: 'Outros'},
            { value: '6', text: 'Utilit. e Motoc. da Amazônia Ocidental'},
            { value: '7', text: 'SUFRAMA'},
          ],
          opModalidadeST: [
            { value: '0', text: 'Preço Tabelado ou Máximo Sugerido'},
            { value: '1', text: 'Lista Negativa (Valor)'},
            { value: '2', text: 'Lista Positiva (valor)'},
            { value: '3', text: 'Lista Neutra (valor)'},
            { value: '4', text: 'Margem Valor Agregado (%)'},
            { value: '5', text: 'Pauta (valor)'},
          ],
        },
        pis:{
          opTipoSituacaoTributaria: [
            { value: '01', text : 'PIS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text : 'PIS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text : 'PIS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text : 'PIS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text : 'PIS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text : 'PIS 07 - Operação Isenta da Contribuição'},
            { value: '08', text : 'PIS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text : 'PIS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text : 'PIS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        },
        cofins:{
          opTipoSituacaoTributaria: [
            { value: '01', text: 'COFINS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text: 'COFINS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text: 'COFINS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text: 'COFINS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text: 'COFINS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text: 'COFINS 07 - Operação Isenta da Contribuição'},
            { value: '08', text: 'COFINS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text: 'COFINS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text: 'COFINS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        }
      },   
      icms: {
        habilitado: {
          comboOP_ICMS_ORIGEM              : true, // Sempre Visivel
          
          //Grupo ICMS Normal
          comboOP_ICMS_MODAL_DETERM_BC     : false,
          edVL_ICMS_PERCENT_REDUC_BC       : false,
          edVL_ICMS_BASE_CALC              : false,
          edVL_ICMS_ALIQUOTA               : false,
          edVL_ICMS_PERC_BC_OPER_PROPRIA   : false,
          edVL_ICMS                        : false,

          comboOP_MOTIVO_DESONERACAO       : false,

          //Grupo ICMS Normal ST
          comboOP_ICMS_MODAL_DETERM_BC_ST  : false,
          edVL_ICMS_PERCENT_REDUC_BC_ST    : false,
          edVL_ICMS_MARGEM_VL_ADIC_ST      : false,
          edVL_ICMS_BASE_CALC_ST           : false,
          edVL_ICMS_ALIQUOTA_ST            : false,
          edVL_ICMS_ST                     : false,
          comboID_UF_ICMS_ST               : false,

          //Grupo ICMS Simples
          edVL_ALIQ_APLICAVEL_CALC_CREDITO : false,
          edVL_CREDITO_ICMS_APROVEITADO    : false,

          //Grupo ICMS Simples ST
          edVL_ICMS_BC_ST_RETIDO_ANT       : false,
          edVL_ICMS_ST_RETIDO_ANT          : false,

          
        }
      },

    }
  },
  
  computed: {
    textoImposto() {
      return this.cliente.ISENTO_ICMS ? (this.cliente.ISENTO_ICMS == 1 ? 'ISENTO' : 'SUJEITO') : 'AUSENTE'
    },
    produtoTotal: {
       get() {
        return 0.00
       },
       set() {

       }
    },
    habilitaBotaoProdutos() {
      //return ((!this.controles.fechada) && (!this.classeLabelVermelhoCliente))
      
      return (this.controles.fechada == false) && (this.controles.clienteBloqueado == false)
    },
    habilitaBotaoExcluir() {
      return (this.venda.SEQUENCIA > 0) && 
             (['2','3'].includes(this.venda.SITUACAO))
    },
    habilitaBotaoGravar() {
      return (this.controles.fechada == false) && 
             (this.controles.clienteBloqueado == false) &&
             (['2','3','4','5'].includes(this.venda.SITUACAO))
    },
    habilitaBotaoFinalizar() {
      return (this.controles.fechada == false) && 
             (this.controles.clienteBloqueado == false) &&
             (this.controles.expedicaoDireta == false) &&
             (this.controles.expedicaoConferencia == false) &&
             (['2'].includes(this.venda.SITUACAO))
    },
    habilitaBotaoLiberarTerminal() {
      return (this.controles.fechada == false) && 
             (this.controles.clienteBloqueado == false) &&
             (this.controles.expedicaoDireta == true) &&
             (['2'].includes(this.venda.SITUACAO)) 
    },
    habilitaBotaoSolicitarConferencia() {
      return (this.controles.fechada == false) &&
             (this.controles.clienteBloqueado == false) &&
             (this.controles.expedicaoConferencia == true) &&
             (['2','3'].includes(this.venda.SITUACAO))
    },
    

    valN_VENDA(){
      return ((this.venda.N_VENDA ) && (this.venda.N_VENDA > 0)) ? true : false
    },
    valCOD_CLI(){
      return ((this.venda.COD_CLI ) && (this.venda.COD_CLI > 0)) ? true : false
    },
    valCOD_VENDEDOR(){
      return ((this.venda.COD_VENDEDOR ) && (this.venda.COD_VENDEDOR > 0)) ? true : false
    },
    valCOD_CONFERENTE(){
      return ((this.venda.COD_CONFERENTE ) && (this.venda.COD_CONFERENTE > 0)) ? true : false
    },
    valCOD_MOTORISTA(){
      return ((this.venda.COD_MOTORISTA ) && (this.venda.COD_MOTORISTA > 0)) ? true : false
    },
    valOP_FORMA_PAGTO() {
      return ((this.venda.OP_FORMA_PAGTO ) && (this.venda.OP_FORMA_PAGTO != '')) ? true : false
    },
    valPAG1() {
      return this.venda.PAG1 == null ? false : true
    },
    valCOD_PRO(){
      return ((this.item.COD_PRO ) && (this.item.COD_PRO > 0)) ? true : false
    },
    valVL_UNT(){
      return ((this.item.VL_UNT ) && (this.item.VL_UNT > 0)) ? true : false
    },
    valPECAS_PEDIDO(){
      return ((this.item.PECAS_PEDIDO ) && (this.item.PECAS_PEDIDO > 0)) ? true : false
    },
    valOBS3() {
      return ((this.venda.OBS3 ) && (this.venda.OBS3 != '')) ? true : false
    },
    totalVenda() {
      if (this.venda.VL_TOTAL_PREVISTO && this.venda.VL_TOTAL_PREVISTO > 0) {
        return this.venda.VL_TOTAL_PREVISTO
      }
      if (!this.controles.vendaPorPecas && this.tabelaItens.items && this.tabelaItens.items.length > 0) {
        return this.tabelaItens.items.reduce((soma, it) => soma + (it.VL_TOTAL_PREVISTO || it.VL_TOTAL_BRUTO || 0), 0)
      }
      return this.venda.VL_TOTAL_NFE && this.venda.VL_TOTAL_NFE > 0 ? this.venda.VL_TOTAL_NFE : 0.00
    },
    limiteCredito: {
      get() {
        return this.cliente.LIMITE_CREDITO && this.cliente.LIMITE_CREDITO > 0 ? this.cliente.LIMITE_CREDITO : 0.00
      },
      set(){
        
      }
    },
    totalBruto() {
      return this.item.VL_TOTAL_BRUTO && this.item.VL_TOTAL_BRUTO > 0 ? this.item.VL_TOTAL_BRUTO : 0.00
    },
    
    totalQuant(){
      let soma = 0.00
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            soma += it.QUANT
          })
        } 
        return soma
      } else {
        return 0.00
      }
    },
    totalQuantPedido() {
      let soma = 0.00
      if (this.tabelaItens.items) {
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            soma += Number(it.QUANT_PEDIDO || 0)
          })
        }
        return soma
      } else {
        return 0.00
      }
    },
    totalQuantEmbarcada() {
      let soma = 0.00
      if (this.tabelaItens.items) {
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            soma += Number(it.QUANT || 0)
          })
        }
        return soma
      } else {
        return 0.00
      }
    },
    totalPecas:{
      get() {
        let soma = 0
        if (this.tabelaItens.items){
          if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
            [...this.tabelaItens.items].forEach(it => {
              soma += it.PECAS_PEDIDO
            })
          } 
          return soma
        } else {
          return 0
        }
      },
      set() {
        // Implementar lógica para definir o valor de totalPecas
      }  
    },
    tamanhocampoPagina () {
      if (this.venda.PAGINA) {
        return this.venda.PAGINA.length > 2 ? null : false
      }
      return false
    }
  },
  methods: {
    async imprimirPedidoEstimado() {
      await imprimirPedidoEstimado(this.$http, this.venda.SEQUENCIA, {
        venda: this.venda,
        itens: this.tabelaItens.items
      })
    },
    voltar() {
        this.$router.push({ path: '/movimentos/pedidovendaweb/listagem'})
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.produtos.totalRows = filteredItems.length
      this.produtos.currentPage = 1
    },
    extrairMensagemErroApi(err) {
      if (err && err.response && err.response.data) {
        if (typeof err.response.data === 'string') return err.response.data
        if (err.response.data.mensagem) return err.response.data.mensagem
        if (err.response.data.message) return err.response.data.message
      }

      return err && err.message ? err.message : err
    },
    limparCriticaEstoqueModalItem() {
      this.estoqueCriticaModalItem.visivel = false
      this.estoqueCriticaModalItem.mensagem = ''
      this.estoqueCriticaModalItem.itens = []
    },
    aplicarCriticaEstoqueModalItem(payload) {
      const itensCritica = Array.isArray(payload && payload.itens) ? payload.itens : []
      if (!itensCritica.length) return

      this.estoqueCriticaModalItem.visivel = true
      this.estoqueCriticaModalItem.mensagem = payload && payload.mensagem
        ? payload.mensagem
        : 'O saldo do produto mudou durante a edicao.'
      this.estoqueCriticaModalItem.itens = itensCritica

      const itemCritica = itensCritica[0]
      const pecasDisponiveis = Number(itemCritica.PECAS_DISPONIVEIS_ATUAL || 0)
      const pecasAjustadas = Number(itemCritica.PECAS_PEDIDO_AJUSTADO || 0)

      this.estoqueProduto.PECAS = pecasDisponiveis
      this.item.PECAS_PEDIDO = pecasAjustadas
      this.item.QUANT_PEDIDO = pecasAjustadas
    },

    async abrirModalAlterarProduto(item) {
      if (this.controles.fechada) {
        return
      }
      this.tabIndexItem = 0
      this.limparCriticaEstoqueModalItem()

      if (item[0] && item[0].CONTROLE) {
        try {
          this.$store.commit('controle/setAguardando', true)
          this.controles.itemAlteracao = true
          try {
            const result = await this.$http.get(`/api/protected/venda/item/getById/${item[0].CONTROLE}`)
            this.controles.montandoItem = true
            this.limparItem(true, result.data[0])
            this.$refs['modal-item'].show()
          } catch(err) {
            this.controles.montandoItem = false
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          }
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      }
    },
    async postItem(){
      if (! this.avisosItem()) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Preencha todas as informações OBRIGATÓRIAS!!!` )
        return  
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        this.item.SEQUENCIA = this.venda.SEQUENCIA
        this.item.QUANT_PEDIDO = this.item.PECAS_PEDIDO
      
        let pacote = {
          venda : this.venda,
          item : this.item
        }
        try {
          await this.$http.post(`/api/protected/vendapedido/item/post`, pacote)
        } catch (err) {
          if (err.response && err.response.data && err.response.data.tipo === 'ESTOQUE_INSUFICIENTE') {
            this.aplicarCriticaEstoqueModalItem(err.response.data)
            return
          }
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', this.extrairMensagemErroApi(err) )
          return
        }
        try {
          const response = await this.$http.get('/api/protected/vendapedido/item/getListagemByVenda/'+this.venda.SEQUENCIA)
          this.montarTabelaItens(response.data)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
        try {
          const response = await this.$http.get(`/api/protected/vendapedido/getById/${this.venda.SEQUENCIA}`)
          this.venda = response.data[0]
          this.ajustarCamposTabelaVendas(this.venda)
          this.$refs['modal-item'].hide()
        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
        this.$refs['modal-item'].hide()
        
        
      } finally {
          this.$store.commit('controle/setAguardando', false)
      }
    },
    focusModalItem() {
       this.$nextTick(() => {
        if (!this.controles.itemAlteracao) {
          // foca no autocomplete do código do produto
          this.$refs.edCOD_PRO?.$refs?.auto?.$refs?.autocomplete?.focus()
        } else {
          const input = this.$refs.edPECAS_PEDIDO?.$refs?.autoNumericElement
          if (input && typeof input.focus === 'function') {
            input.focus()
          } else {
            console.warn('Campo edPECAS_PEDIDO não disponível ou ainda não montado')
          }
        }
      })
    },
    async atualizarPaginaPesquisa(ctx) {
      try {
        await this.$store.dispatch('pedidoVendaWeb/GERAR_LISTA')
        return true
      } catch (error) {
        return false
      }
    },
    async gravarPedidoEVoltar() {
      if (!this.avisosVenda()) {
        return
      }
      
      try{
        this.$store.commit('controle/setAguardando', true)
        try {
          
          if (this.controles.vendaAlteracao == false)
            await this.$http.post(`/api/protected/venda/postOnly`, this.venda)
          else 
            await this.$http.post(`/api/protected/venda/editDesktop`, {venda: this.venda})      

          //Atualizar listagem da pagina de Pesquisa
          await this.atualizarPaginaPesquisa()
          this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
          this.$router.push('/movimentos/pedidovendaweb/listagem')
        } catch (err) {
          const mensagemErro =
            (err.response && err.response.data && (err.response.data.message || JSON.stringify(err.response.data))) ||
            err.message || 'Erro inesperado'

          this.$root.$bvToast.toast(`Aviso: ${mensagemErro}`, {
            title: 'Erro',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async gravarVendaSimples() {
      try {  
        const vendaResult = await this.$http.post(`/api/protected/vendapedido/postOnly`, this.venda)
        this.venda = vendaResult.data
        this.ajustarCamposTabelaVendas(this.venda)
        return true
      } catch(err) {
          throw new Error(err)
      }
    },
    async alterarVendaSimples() {
      try { 
        const response = await this.$http.post(`/api/protected/vendapedido/edit`, this.venda)
        this.venda = response.data
        this.ajustarCamposTabelaVendas(this.venda)
        return true
      } catch(err) {
          throw new Error(err)
      }
    },
    variantEstoquePecas (value) {
      let $variant = 'text-red'
      if (value > 0) {
        $variant = 'text-blue'
      } 
      return $variant
    },
    async abrirModalItemNovo () {
      // A VENDA AINDA NÃO FOI SALVA
      if (this.venda.SEQUENCIA == null) {
        if (!this.venda.COD_CLI) {
          this.$root.$bvToast.toast(`É necessário informar o CLIENTE!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: false
          })
          return
        }

        try {
          this.venda.USUARIO = window.localStorage.getItem('login')
          const gravouVenda =  await this.gravarVendaSimples()
           
          if (gravouVenda == false) {
            //não conseguiu gravar a nova venda
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Serviço indisponível! Não foi possivel executar a operação' )
            return
          }

          this.ajustarCamposTabelaVendas(this.venda)

          // Atualiza a URL para o modo de edição
          this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
          this.$router.replace(`/movimentos/pedidovendaweb/edit/${this.venda.SEQUENCIA}`)

        } catch (err) {
          console.error('Erro ao iniciar nova venda:', err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
      }

      // CONTROLES ATUALIZADOS
      this.vendaIdEditar = this.venda.SEQUENCIA
      this.controles.vendaAlteracao = true
      this.controles.fechada = this.venda.SITUACAO === '0'

      this.tabIndexItem = 0
      this.controles.montandoItem = false
      this.limparCriticaEstoqueModalItem()

      this.limparItem(false, {})

      this.item.SEQUENCIA      = this.venda.SEQUENCIA
      this.item.OP_TRIBUTACAO  = '0'
      this.item.COD_CENTRO     = this.parametros.COD_CENTROESTOQUE
      this.item.ID_CFOP        = this.parametros.COD_CFOPVEN
      

      this.controles.COD_PRO = null
      this.controles.itemAlteracao = false

      this.$refs['modal-item'].show()
    },
    abrirModalItemEditar (item) {
      if (this.controles.fechada) {
        return
      }

      if (!item[0] && !item[0].CONTROLE) {
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        this.controles.itemAlteracao = true
        try {
          const result = this.$http.get(`/api/protected/vendapedido/item/getById/${item[0].CONTROLE}`)
          this.limparItem(true, result.data[0])
          
          this.$refs['modal-item'].show()
          
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
      } finally {
          this.$store.commit('controle/setAguardando', false)
      }
    },
    montarTabelaItens(itens) {
      this.tabelaItens.items = []
          
      if ( (itens) && (itens.length) ) {

        const dados = itens
        for (let i = 0; i < dados.length; i++) {
          
          // Calcular VL_TOTAL_BRUTO se não estiver definido no banco
          if (!dados[i].VL_TOTAL_BRUTO || dados[i].VL_TOTAL_BRUTO === 0) {
            dados[i].VL_TOTAL_BRUTO = (dados[i].PECAS_PEDIDO || 0) * (dados[i].VL_UNT || 0)
          }
          if (!dados[i].VL_TOTAL_PREVISTO || dados[i].VL_TOTAL_PREVISTO === 0) {
            dados[i].VL_TOTAL_PREVISTO = (dados[i].QUANT_PEDIDO || 0) * (dados[i].VL_UNT || 0)
          }

          if ((dados[i].VL_UNT) && (dados[i].VL_UNT > 0) ) {
              dados[i].VL_UNT = dados[i].VL_UNT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2})
          }
          
          this.tabelaItens.items.push(dados[i])
        }  
      }
    },
    async deleteItem(){
      this.$store.commit('controle/setAguardando', true)
      try {
        try {
          await this.$http.post(`/api/protected/vendapedido/item/deleteDesktop`, {vendaItemId: this.itemExcluir.CONTROLE})
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
          return
        }
       
        const vendaResponse = await this.$http.get(`/api/protected/vendapedido/getById/${this.venda.SEQUENCIA}`)
        this.venda = vendaResponse.data[0]
        this.ajustarCamposTabelaVendas(this.venda)
        const responseItens = await this.$http.get('/api/protected/vendapedido/item/getListagemByVenda/'+this.venda.SEQUENCIA)
        this.montarTabelaItens(responseItens.data)

        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Item removido com sucesso!')
      } finally {
        this.$refs['modal-excluir-item'].hide()
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async editItem() {
      this.$store.commit('controle/setAguardando', true)
      this.item.SEQUENCIA = this.venda.SEQUENCIA
      this.item.QUANT_PEDIDO = this.item.PECAS_PEDIDO
      try {
        try {
          await this.$http.post(`/api/protected/vendapedido/item/edit`, 
          { item : this.item,
            venda: this.venda
          })
        } catch (err) {
          if (err.response && err.response.data && err.response.data.tipo === 'ESTOQUE_INSUFICIENTE') {
            this.aplicarCriticaEstoqueModalItem(err.response.data)
            return
          }
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', this.extrairMensagemErroApi(err))
          return
        }

        this.$refs['modal-item'].hide()
        
        try {
          const itensResponse = await this.$http.get('/api/protected/vendapedido/item/getListagemByVenda/'+this.venda.SEQUENCIA)
          this.montarTabelaItens(itensResponse.data)
          const vendaResult = await this.$http.get(`/api/protected/vendapedido/getById/${this.venda.SEQUENCIA}`)
          this.venda = vendaResult.data[0]
          this.ajustarCamposTabelaVendas(this.venda)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
        }
      } finally {  
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    handleKeydown(event) {
      const key = event.key.toLowerCase()
      const ctrl = event.ctrlKey
      const alt = event.altKey
      const modalAberto = this.$refs.modalItem?.isShow === true

      const mapTeclas = {
        insert: () => this.abrirModalItemNovo(),
        f11: () => this.executarFluxoF11(),
        f10: () => this.gravarPedidoEVoltar(),
        escape: () => this.$refs.modalItem?.hide()
      }

      // Ctrl + F10 ou Ctrl + F11 só funcionam se o modal estiver fechado
      if ((key === 'f10' || key === 'f11') && ctrl && !modalAberto) {
        event.preventDefault()
        mapTeclas[key]?.()
      }

      // Insert continua sem Ctrl, se modal estiver fechado
      else if (key === 'insert' && !modalAberto) {
        event.preventDefault()
        mapTeclas.insert?.()
      }

      // Escape continua sem Ctrl, apenas se o modal estiver aberto
      else if (key === 'escape' && modalAberto) {
        event.preventDefault()
        mapTeclas.escape?.()
      }

      // Alt + alguma letra
      else if (alt && !modalAberto) {
        switch (key) {
          case 'v':
            event.preventDefault()
            this.$router.go(-1)
            break
          // adicione mais atalhos ALT aqui
        }
      }
    },
    executarFluxoF11() {
      if (this.habilitaBotaoSolicitarConferencia) {
        return this.solicitarConferencia()
      }

      if (this.habilitaBotaoLiberarTerminal) {
        return this.liberarProTerminal()
      }

      if (this.habilitaBotaoFinalizar) {
        return this.finalizarVenda()
      }
    },
    gerarComboParcelas() {
      this.parcelasVezes = [] 
      for (let i = 0; i < 48; i++) {
        this.parcelasVezes.push({ value: (i+1).toString() , text: (i+1)+'X' })
      }
    },
    gerarDias() {
      this.dias = []
      this.dias.push({ value: null , text: '' }) 
      this.dias.push({ value: '0' , text: ' 0 Nenhum' })
      for (let i = 0; i < 60; i++) {
        this.dias.push({ value: (i+1).toString() , text: (i+1)+' dias' })
      }
      this.dias.push({ value: '120' , text: ' 120 dias' })
      this.dias.push({ value: '150' , text: ' 150 dias' })
      this.dias.push({ value: '180' , text: ' 180 dias' })
      this.dias.push({ value: '210' , text: ' 210 dias' })
      this.dias.push({ value: '240' , text: ' 240 dias' })
      this.dias.push({ value: '270' , text: ' 270 dias' })
      this.dias.push({ value: '300' , text: ' 300 dias' })
      this.dias.push({ value: '360' , text: ' 360 dias' })
    }, 
    async finalizarVenda(){

      if (this.venda.OP_FORMA_PAGTO === 'V' ) {
        this.venda.NR_PARCELAS = null
        this.venda.PAG1 = null
        this.venda.DT_INICIAR_PAGAMENTO = null
      }

      if (!this.avisosVenda()) {
        return
      } 

      if (this.vendaIdEditar != null)  {
        this.venda.DT_ALTERACAO = new Date()
        this.venda.TX_USUARIO_ALTERACAO = ''
        this.venda.DT_ALTERACAO_SISTEMA = new Date()
        if (this.venda.FORMA === 'VENDA' ) {
            this.venda.TIPO_VEN = '0'
        }
      }
      
     let itens = ''
      
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            itens += it.NOME_PRODUTO.substring(0,4)
          })
        } 
      }

      this.venda.ITENS = itens.substring(0, 49)
      this.venda.USUARIO_PEDIDO = window.localStorage.getItem('login')
      this.venda.USUARIO_LANCAMENTO_WEB = window.localStorage.getItem('login')
      
      let pacote = {
        venda: this.venda,
        itens: this.tabelaItens.items
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.post(`/api/protected/vendapedido/finalizar`, pacote) 
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
       

        // Atualiza listagem e redireciona (independente do relatório ter dado certo ou não)
        this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
        await this.atualizarPaginaPesquisa()
        
        
        this.$router.push('/movimentos/pedidovendaweb/listagem')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async liberarProTerminal(){

      if (this.venda.OP_FORMA_PAGTO === 'V' ) {
        this.venda.NR_PARCELAS = null
        this.venda.PAG1 = null
        this.venda.DT_INICIAR_PAGAMENTO = null
      }

      if (!this.avisosVenda()) {
        return
      } 

      let itens = ''
      
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            itens += it.NOME_PRODUTO.substring(0,4)
          })
        } 
      }

      this.venda.ITENS = itens.substring(0, 49)
      this.venda.USUARIO_PEDIDO = window.localStorage.getItem('login')
      this.venda.USUARIO_LANCAMENTO_WEB = window.localStorage.getItem('login')
      // QUANDO GRAVA O PEDIDO DEVERA FICAR EM AGUARDANDO EXPEDICAO 
      this.venda.SITUACAO = '4' // EM ORDEM DE EXPEDICAO


      this.$store.commit('controle/setAguardando', true)
      try {
        try {
          await this.$http.post(`/api/protected/venda/editDesktop`, {venda: this.venda})

        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        /*
        try {
          let response = await this.$http.get(`/api/protected/relatorios/relvendapedido?id=${this.venda.SEQUENCIA}` , {responseType: 'arraybuffer'})
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `relPedido.pdf`) 
          link.download = 'relPedido.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = `${this.venda.N_VENDA} - Pedido`
            }, 3000);
          }

          this.$router.go(-1)
          
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          this.$router.go(-1)
        }
          */

        await this.atualizarPaginaPesquisa()
        this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
        this.$router.push('/movimentos/pedidovendaweb/listagem')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async solicitarConferencia(){
      if (!this.venda.SEQUENCIA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Grave o pedido antes de solicitar separacao.')
        return
      }

      const situacaoAtual = String(this.venda.SITUACAO || '').trim()
      if (!['2', '3'].includes(situacaoAtual)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Apenas pedidos em lancamento ou AGUARD. ORDEM podem solicitar separacao.')
        return
      }

      const confirmar = await this.$bvModal.msgBoxConfirm('Solicitar a separacao deste pedido para o estoque?', {
        title: 'Solicitar Separacao',
        okTitle: 'SIM, SOLICITAR',
        cancelTitle: 'CANCELAR',
        okVariant: 'info',
        centered: true
      })
      if (!confirmar) return

      try {
        this.$store.commit('controle/setAguardando', true)
        if (situacaoAtual === '2') {
          if (this.venda.OP_FORMA_PAGTO === 'V' ) {
            this.venda.NR_PARCELAS = null
            this.venda.PAG1 = null
            this.venda.DT_INICIAR_PAGAMENTO = null
          }

          if (!this.avisosVenda()) {
            return
          }

          if (this.vendaIdEditar != null)  {
            this.venda.DT_ALTERACAO = new Date()
            this.venda.TX_USUARIO_ALTERACAO = ''
            this.venda.DT_ALTERACAO_SISTEMA = new Date()
            if (this.venda.FORMA === 'VENDA' ) {
              this.venda.TIPO_VEN = '0'
            }
          }

          let itens = ''
          if (this.tabelaItens.items) {
            if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
              [...this.tabelaItens.items].forEach(it => {
                itens += it.NOME_PRODUTO.substring(0,4)
              })
            }
          }

          this.venda.ITENS = itens.substring(0, 49)
          this.venda.USUARIO_PEDIDO = window.localStorage.getItem('login')
          this.venda.USUARIO_LANCAMENTO_WEB = window.localStorage.getItem('login')

          try {
            await this.$http.post(`/api/protected/vendapedido/finalizar`, {
              venda: this.venda,
              itens: this.tabelaItens.items
            })
            this.venda.SITUACAO = '3'
          } catch (err) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
            return
          }
        }

        try {
          await this.$http.post(`/api/protected/vendapedido/solicitarSeparacao`, {
            pedidoId: this.venda.SEQUENCIA,
            usuario: window.localStorage.getItem('login')
          })
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }

        this.venda.SITUACAO = '7'
        this.venda.OP_CONFERENCIA_VENDA = '1'
        this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
        await this.atualizarPaginaPesquisa()
        this.$router.push('/movimentos/pedidovendaweb/listagem')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    
    async abrirModalExcluirItem(item) { 
      this.$store.commit('controle/setAguardando', true)
      this.itemExcluir.CODIGO_NOME_PRODUTO = item.CODIGO_NOME_PRODUTO
      this.itemExcluir.CONTROLE = item.CONTROLE
      try{
        try {
          const result = await this.$http.get('/api/protected/vendapedido/item/getById/'+this.itemExcluir.CONTROLE)
          this.itemExcluir.CONTROLE = result.data[0].CONTROLE
          this.itemExcluir.COD_PRO = result.data[0].COD_PRO
          this.itemExcluir.COD_CENTRO = result.data[0].COD_CENTRO
          this.itemExcluir.QUANT = result.data[0].QUANT
          this.itemExcluir.PECAS_PEDIDO = result.data[0].PECAS_PEDIDO
          this.itemExcluir.PECAS = result.data[0].PECAS
          this.itemExcluir.TX_UNIDADE_COMERCIAL = result.data[0].ID_UNIDADE_COMERCIAL
          this.itemExcluir.VL_UNT = result.data[0].VL_UNT
          this.itemExcluir.VL_DESCONTO = result.data[0].VL_DESCONTO
          this.itemExcluir.VL_TOTAL_BRUTO = result.data[0].VL_TOTAL_BRUTO
          
          this.itemExcluir.QUANT_MASK          = result.data[0].QUANT ? result.data[0].QUANT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          this.itemExcluir.VL_UNT_MASK         = result.data[0].VL_UNT ? result.data[0].VL_UNT.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          this.itemExcluir.VL_DESCONTO_MASK    = result.data[0].VL_DESCONTO ? result.data[0].VL_DESCONTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          this.itemExcluir.VL_TOTAL_BRUTO_MASK = result.data[0].VL_TOTAL_BRUTO ? result.data[0].VL_TOTAL_BRUTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          
          this.$refs['modal-excluir-item'].show()
        } catch(err)  {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async reabrir() {
      let situacao = this.venda.SITUACAO
      try {
        
        this.$store.commit('controle/setAguardando', true)
        try {
          this.venda.SITUACAO = '2' //Em cadastro
          await this.$http.post(`/api/protected/vendapedido/reabrir`, this.venda)
          this.controles.fechada = false
          this.$refs['modal-reabrir'].hide()
        } catch(err)  {
          this.venda.SITUACAO = situacao
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async cancelar() {
      try {
        this.$store.commit('controle/setAguardando', true)
        const body = {
          id: this.venda.SEQUENCIA,
          login: window.localStorage.getItem('login'),
          motivo: null
        }
        
        try {
          await this.$http.post(`/api/protected/vendapedido/cancelar`, body)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return 
        }
        await this.$store.dispatch('pedidoVendaWeb/GERAR_LISTA')
      
        this.controles.fechada = false
        this.$refs['modal-cancelar'].hide()

        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'O Pedido foi cancelado com Sucesso!' )
        this.voltar()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    abrirModalReabrir(){
       this.$refs['modal-reabrir'].show()
    },
    abrirModalCancelamento(){
       this.$refs['modal-cancelar'].show()
    },
    colorirTabSelecionada(idx) {
      if (this.tabIndex === idx) {
        return ['bg-gray-600', 'text-white']
        //return ['bg-gray-600', 'text-light']
      } else {
        if (idx === 3 ) {
          return ['bg-green', 'text-light']
        } else {
          return ['bg-dark', 'text-light']
        }
      }
    },
    getStatusOrdemEntrega(item) {
      return String((item && item.ORDEM_ENTREGA_STATUS) || '').trim()
    },
    isEntregaConfirmada(item) {
      return String((item && item.OP_RETORNO_ENTREGA) || '0').trim() === '1'
    },
    colorirStatus(valor, item = null) {
      if (valor == '0') return 'danger'
      else if (valor == '1') {
        if (item && this.isEntregaConfirmada(item)) return 'success'
        if (!item || !item.ORDEM_ENTREGA_ID) return 'success'
        const statusOrdem = this.getStatusOrdemEntrega(item)
        if (['0', '1'].includes(statusOrdem)) return 'warning'
        if (['2', '3'].includes(statusOrdem)) return 'primary'
        if (statusOrdem === '4') return 'info'
        return 'primary'
      }
      else if (valor == '2') return 'warning'
      else if (valor == '3') return 'info'
      else if (valor == '4') return 'secondary'
      else if (valor == '5') return 'indigo'
      else if (valor == '6') return 'primary'
      else if (valor == '7') return 'warning'
      else if (valor == '8') return 'indigo'
      else return 'info'
    },
    avisosVenda(){
      let retorno = true
      if (!this.valN_VENDA) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe o Número do Pedido!! ` )
      } 
      if (!this.valCOD_CLI) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe o Cliente` )
      } 
      if (!this.valCOD_VENDEDOR) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe o Vendedor` )
      } 
      if (!this.valOP_FORMA_PAGTO) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe a Forma de Pagamento` )
      } 
      if ((!this.tabelaItens.items.length) || (this.tabelaItens.items.length <= 0) ) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Adicione Produtos` )
      } 
      if (this.venda.OP_FORMA_PAGTO === 'P' ) { // A PRAZO
         if (!this.valPAG1) {
          retorno = false
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe o Número de Parcelas` )
         }
      }

      return retorno
    },
    avisosItem(){
      return this.valCOD_PRO && this.valPECAS_PEDIDO && this.valVL_UNT
    },
    
    onHidden_botaoGerarDocumento() {
      // Return focus to the button
      //console.log(this.$refs)
      //this.$refs.ob_edDocumento.focus()
      this.$refs.edCOD_CLI.$refs.auto.$refs.autocomplete.focus()
    },
    calcularPercentualLimiteCredito(){
      let credito = 0.00
      let usado = 0.00
      if (this.cliente.VL_CREDITO !== null && this.cliente.VL_CREDITO > 0) {
        credito = this.cliente.VL_CREDITO
      }
      if (this.cliente.LIMITE_CREDITO !== null && this.cliente.LIMITE_CREDITO > 0) {
        usado = this.cliente.LIMITE_CREDITO
      } 
      if (credito <= 0) {
        return 100
      } else {
        return 100 - ((credito - usado) / credito) * 100
      }
      
    },
    postProduto(){

    },
    post () {
      if ( !this.venda.SEQUENCIA || this.venda.SEQUENCIA === null || this.venda.SEQUENCIA === undefined ) {
        this.novo()
      } else {
        this.editar()
      }
    },
    limparItem(alteracao, item) {
      this.item.CONTROLE                       =    item.CONTROLE                       ? item.CONTROLE                       : null 
      this.item.SEQUENCIA                      =    item.SEQUENCIA                      ? item.SEQUENCIA                      : null 
      this.item.COD_PRO                        =    item.COD_PRO                        ? item.COD_PRO                        : null 
      this.item.EAN                            =    item.EAN                            ? item.EAN                            : null 
      this.item.QUANT                          =    item.QUANT                          ? item.QUANT                          : 0.00 
      this.item.VL_UNT                         =    item.VL_UNT                         ? item.VL_UNT                         : 0.00 
      this.item.VL_CUSTO                       =    item.VL_CUSTO                       ? item.VL_CUSTO                       : 0.00 
      this.item.UND_PECAS                      =    item.UND_PECAS                      ? item.UND_PECAS                      : null 
      this.item.PECAS                          =    item.PECAS                          ? item.PECAS                          : 0 
      this.item.DT_VENDA                       =    item.DT_VENDA                       ? item.DT_VENDA                       : new Date() 
      this.item.TIPO_CLI                       =    item.TIPO_CLI                       ? item.TIPO_CLI                       : null 
      this.item.MARCA                          =    item.MARCA                          ? item.MARCA                          : null 
      this.item.TIPO_VEN                       =    item.TIPO_VEN                       ? item.TIPO_VEN                       : null 
      this.item.ALTERA                         =    item.ALTERA                         ? item.ALTERA                         : null 
      this.item.ITEM                           =    item.ITEM                           ? item.ITEM                           : null 
      this.item.VL_COMISSAO                    =    item.VL_COMISSAO                    ? item.VL_COMISSAO                    : 0.00 
      this.item.COD_CENTRO                     =    item.COD_CENTRO                     ? item.COD_CENTRO                     : null 
      this.item.ICMS                           =    item.ICMS                           ? item.ICMS                           : null 
      this.item.IPI                            =    item.IPI                            ? item.IPI                            : null 
      this.item.ISS                            =    item.ISS                            ? item.ISS                            : null 
      this.item.IRRF                           =    item.IRRF                           ? item.IRRF                           : null 
      this.item.ICMSSUBSTITUI                  =    item.ICMSSUBSTITUI                  ? item.ICMSSUBSTITUI                  : null 
      this.item.FORMA                          =    item.FORMA                          ? item.FORMA                          : null 
      this.item.ID_CFOP                        =    item.ID_CFOP                        ? item.ID_CFOP                        : null 
      this.item.OP_STATUS_PRECO                =    item.OP_STATUS_PRECO                ? item.OP_STATUS_PRECO                : null 
      this.item.VL_TOTAL_BRUTO                 =    item.VL_TOTAL_BRUTO                 ? item.VL_TOTAL_BRUTO                 : 0.00 
      this.item.VL_TOTAL_DESCONTO              =    item.VL_TOTAL_DESCONTO              ? item.VL_TOTAL_DESCONTO              : 0.00 
      this.item.VL_DESCONTO_PERC               =    item.VL_DESCONTO_PERC               ? item.VL_DESCONTO_PERC               : 0.00 
      this.item.TX_NCM                         =    item.TX_NCM                         ? item.TX_NCM                         : null 
      this.item.TX_NOME_PRODUTO                =    item.TX_NOME_PRODUTO                ? item.TX_NOME_PRODUTO                : null 
      this.item.TX_UNIDADE_COMERCIAL           =    item.TX_UNIDADE_COMERCIAL           ? item.TX_UNIDADE_COMERCIAL           : null 
      this.item.OP_OCORRENCIA_PRECO            =    item.OP_OCORRENCIA_PRECO            ? item.OP_OCORRENCIA_PRECO            : null 
      this.item.VL_DESCONTO                    =    item.VL_DESCONTO                    ? item.VL_DESCONTO                    : 0.00 
      this.item.ID_UNIDADE_COMERCIAL           =    item.ID_UNIDADE_COMERCIAL           ? item.ID_UNIDADE_COMERCIAL           : null 
      this.item.OP_TRIBUTACAO                  =    item.OP_TRIBUTACAO                  ? item.OP_TRIBUTACAO                  : null 
      this.item.CEST                           =    item.CEST                           ? item.CEST                           : null 
      this.item.QUANT_BKP                      =    item.QUANT_BKP                      ? item.QUANT_BKP                      : null 
      this.item.QUANT_RETORNO                  =    item.QUANT_RETORNO                  ? item.QUANT_RETORNO                  : null 
      this.item.PECAS_BKP                      =    item.PECAS_BKP                      ? item.PECAS_BKP                      : null 
      this.item.PECAS_RETORNO                  =    item.PECAS_RETORNO                  ? item.PECAS_RETORNO                  : null 
      this.item.PECAS_PEDIDO                   =    item.PECAS_PEDIDO                   ? item.PECAS_PEDIDO                   : null 
      this.item.OBS_RETORNO                    =    item.OBS_RETORNO                    ? item.OBS_RETORNO                    : null 
      this.item.TX_OBSERVACOES                 =    item.TX_OBSERVACOES                 ? item.TX_OBSERVACOES                 : null 
      
      if (alteracao == true) {
        this.item.OP_ICMS_SITUACAO_TRIBUTARIA    =    item.OP_ICMS_SITUACAO_TRIBUTARIA    ? item.OP_ICMS_SITUACAO_TRIBUTARIA    : null 
        this.item.OP_ICMS_ORIGEM                 =    item.OP_ICMS_ORIGEM                 ? item.OP_ICMS_ORIGEM                 : null 
        this.item.OP_ICMS_MODAL_DETERM_BC        =    item.OP_ICMS_MODAL_DETERM_BC        ? item.OP_ICMS_MODAL_DETERM_BC        : null 
        this.item.VL_ICMS_PERCENT_REDUC_BC       =    item.VL_ICMS_PERCENT_REDUC_BC       ? item.VL_ICMS_PERCENT_REDUC_BC       : null 
        this.item.VL_ICMS_BASE_CALC              =    item.VL_ICMS_BASE_CALC              ? item.VL_ICMS_BASE_CALC              : null 
        this.item.VL_ICMS_ALIQUOTA               =    item.VL_ICMS_ALIQUOTA               ? item.VL_ICMS_ALIQUOTA               : null 
        this.item.VL_ICMS                        =    item.VL_ICMS                        ? item.VL_ICMS                        : null 
        this.item.OP_ICMS_MODAL_DETERM_BC_ST     =    item.OP_ICMS_MODAL_DETERM_BC_ST     ? item.OP_ICMS_MODAL_DETERM_BC_ST     : null 
        this.item.VL_ICMS_MARGEM_VL_ADIC_ST      =    item.VL_ICMS_MARGEM_VL_ADIC_ST      ? item.VL_ICMS_MARGEM_VL_ADIC_ST      : null 
        this.item.VL_ICMS_PERCENT_REDUC_BC_ST    =    item.VL_ICMS_PERCENT_REDUC_BC_ST    ? item.VL_ICMS_PERCENT_REDUC_BC_ST    : null 
        this.item.VL_ICMS_BASE_CALC_ST           =    item.VL_ICMS_BASE_CALC_ST           ? item.VL_ICMS_BASE_CALC_ST           : null 
        this.item.VL_ICMS_ALIQUOTA_ST            =    item.VL_ICMS_ALIQUOTA_ST            ? item.VL_ICMS_ALIQUOTA_ST            : null 
        this.item.VL_ICMS_ST                     =    item.VL_ICMS_ST                     ? item.VL_ICMS_ST                     : null 
        this.item.OP_IPI_SITUACAO_TRIBUTARIA     =    item.OP_IPI_SITUACAO_TRIBUTARIA     ? item.OP_IPI_SITUACAO_TRIBUTARIA     : null 
        this.item.OP_IPI_CLASS_ENQ_CIG_BEB       =    item.OP_IPI_CLASS_ENQ_CIG_BEB       ? item.OP_IPI_CLASS_ENQ_CIG_BEB       : null 
        this.item.TX_IPI_CODIGO_ENQUAD_LEGAL     =    item.TX_IPI_CODIGO_ENQUAD_LEGAL     ? item.TX_IPI_CODIGO_ENQUAD_LEGAL     : null 
        this.item.TX_IPI_CNPJ_PRODUTOR           =    item.TX_IPI_CNPJ_PRODUTOR           ? item.TX_IPI_CNPJ_PRODUTOR           : null 
        this.item.TX_IPI_NUM_SELO_CONTROLE       =    item.TX_IPI_NUM_SELO_CONTROLE       ? item.TX_IPI_NUM_SELO_CONTROLE       : null 
        this.item.OP_IPI_TIPO_CALCULO            =    item.OP_IPI_TIPO_CALCULO            ? item.OP_IPI_TIPO_CALCULO            : null 
        this.item.VL_IPI_BASE_CALC               =    item.VL_IPI_BASE_CALC               ? item.VL_IPI_BASE_CALC               : null 
        this.item.VL_IPI_ALIQUOTA                =    item.VL_IPI_ALIQUOTA                ? item.VL_IPI_ALIQUOTA                : null 
        this.item.VL_IPI_QUANT_TOTAL_UND_PADRAO  =    item.VL_IPI_QUANT_TOTAL_UND_PADRAO  ? item.VL_IPI_QUANT_TOTAL_UND_PADRAO  : null 
        this.item.VL_IPI_UNIDADE                 =    item.VL_IPI_UNIDADE                 ? item.VL_IPI_UNIDADE                 : null 
        this.item.VL_IPI                         =    item.VL_IPI                         ? item.VL_IPI                         : null 
        this.item.OP_PIS_SITUACAO_TRIBUTARIA     =    item.OP_PIS_SITUACAO_TRIBUTARIA     ? item.OP_PIS_SITUACAO_TRIBUTARIA     : null 
        this.item.OP_PIS_TIPO_CALCULO            =    item.OP_PIS_TIPO_CALCULO            ? item.OP_PIS_TIPO_CALCULO            : null 
        this.item.VL_PIS_BASE_CALC               =    item.VL_PIS_BASE_CALC               ? item.VL_PIS_BASE_CALC               : null 
        this.item.VL_PIS_ALIQUOTA_PERCENT        =    item.VL_PIS_ALIQUOTA_PERCENT        ? item.VL_PIS_ALIQUOTA_PERCENT        : null 
        this.item.VL_PIS_ALIQUOTA_REAIS          =    item.VL_PIS_ALIQUOTA_REAIS          ? item.VL_PIS_ALIQUOTA_REAIS          : null 
        this.item.VL_PIS_QUANT_VENDIDA           =    item.VL_PIS_QUANT_VENDIDA           ? item.VL_PIS_QUANT_VENDIDA           : null 
        this.item.VL_PIS                         =    item.VL_PIS                         ? item.VL_PIS                         : null 
        this.item.OP_PISST_TIPO_CALCULO          =    item.OP_PISST_TIPO_CALCULO          ? item.OP_PISST_TIPO_CALCULO          : null 
        this.item.VL_PISST_BASE_CALC             =    item.VL_PISST_BASE_CALC             ? item.VL_PISST_BASE_CALC             : null 
        this.item.VL_PISST_ALIQUOTA_PERCENT      =    item.VL_PISST_ALIQUOTA_PERCENT      ? item.VL_PISST_ALIQUOTA_PERCENT      : null 
        this.item.VL_PISST_ALIQUOTA_REAIS        =    item.VL_PISST_ALIQUOTA_REAIS        ? item.VL_PISST_ALIQUOTA_REAIS        : null 
        this.item.VL_PISST_QUANT_VENDIDA         =    item.VL_PISST_QUANT_VENDIDA         ? item.VL_PISST_QUANT_VENDIDA         : null 
        this.item.VL_PISST                       =    item.VL_PISST                       ? item.VL_PISST                       : null 
        this.item.OP_COFINS_SITUACAO_TRIBUTARIA  =    item.OP_COFINS_SITUACAO_TRIBUTARIA  ? item.OP_COFINS_SITUACAO_TRIBUTARIA  : null 
        this.item.OP_COFINS_TIPO_CALCULO         =    item.OP_COFINS_TIPO_CALCULO         ? item.OP_COFINS_TIPO_CALCULO         : null 
        this.item.VL_COFINS_BASE_CALC            =    item.VL_COFINS_BASE_CALC            ? item.VL_COFINS_BASE_CALC            : null 
        this.item.VL_COFINS_ALIQUOTA_PERCENT     =    item.VL_COFINS_ALIQUOTA_PERCENT     ? item.VL_COFINS_ALIQUOTA_PERCENT     : null 
        this.item.VL_COFINS_ALIQUOTA_REAIS       =    item.VL_COFINS_ALIQUOTA_REAIS       ? item.VL_COFINS_ALIQUOTA_REAIS       : null 
        this.item.VL_COFINS_QUANT_VENDIDA        =    item.VL_COFINS_QUANT_VENDIDA        ? item.VL_COFINS_QUANT_VENDIDA        : null 
        this.item.VL_COFINS                      =    item.VL_COFINS                      ? item.VL_COFINS                      : null 
        this.item.OP_COFINSST_TIPO_CALCULO       =    item.OP_COFINSST_TIPO_CALCULO       ? item.OP_COFINSST_TIPO_CALCULO       : null 
        this.item.VL_COFINSST_BASE_CALC          =    item.VL_COFINSST_BASE_CALC          ? item.VL_COFINSST_BASE_CALC          : null 
        this.item.VL_COFINSST_ALIQUOTA_PERCENT   =    item.VL_COFINSST_ALIQUOTA_PERCENT   ? item.VL_COFINSST_ALIQUOTA_PERCENT   : null 
        this.item.VL_COFINSST_ALIQUOTA_REAIS     =    item.VL_COFINSST_ALIQUOTA_REAIS     ? item.VL_COFINSST_ALIQUOTA_REAIS     : null 
        this.item.VL_COFINSST_QUANT_VENDIDA      =    item.VL_COFINSST_QUANT_VENDIDA      ? item.VL_COFINSST_QUANT_VENDIDA      : null 
        this.item.VL_COFINSST                    =    item.VL_COFINSST                    ? item.VL_COFINSST                    : null 
        
        this.item.OP_COMPOE_VALOR_NFE            =    item.OP_COMPOE_VALOR_NFE            ? item.OP_COMPOE_VALOR_NFE            : null 
        this.item.VL_ICMS_BC_ST_RETIDO_ANT       =    item.VL_ICMS_BC_ST_RETIDO_ANT       ? item.VL_ICMS_BC_ST_RETIDO_ANT       : null 
        this.item.VL_ICMS_ST_RETIDO_ANT          =    item.VL_ICMS_ST_RETIDO_ANT          ? item.VL_ICMS_ST_RETIDO_ANT          : null 
        this.item.VL_ICMS_PERC_BC_OPER_PROPRIA   =    item.VL_ICMS_PERC_BC_OPER_PROPRIA   ? item.VL_ICMS_PERC_BC_OPER_PROPRIA   : null 
        this.item.ID_UF_ICMS_ST                  =    item.ID_UF_ICMS_ST                  ? item.ID_UF_ICMS_ST                  : null 
        this.item.VL_CREDITO_ICMS_APROVEITADO    =    item.VL_CREDITO_ICMS_APROVEITADO    ? item.VL_CREDITO_ICMS_APROVEITADO    : null 
        
      
        this.item.OP_MOTIVO_DESONERACAO          =    item.OP_MOTIVO_DESONERACAO          ? item.OP_MOTIVO_DESONERACAO          : null 
        this.item.VL_ALIQ_APLICAVEL_CALC_CREDITO =    item.VL_ALIQ_APLICAVEL_CALC_CREDITO ? item.VL_ALIQ_APLICAVEL_CALC_CREDITO : null 
      }
    },
    async limparVenda () {
      this.venda.SEQUENCIA                 = null
      this.venda.N_VENDA                   = null
      this.venda.DT_SAIDA                  = null,
      this.venda.COD_CLI                   = null
      this.venda.DT_PAG                    = null
      this.venda.PAG1                      = null
      this.venda.PAG2                      = '0'
      this.venda.PAG3                      = null
      this.venda.PAG4                      = null
      this.venda.PAG5                      = null
      this.venda.TIPO                      = null
      this.venda.TIPO_VEN                  = '0'
      this.venda.FORMA                     = 'VENDA'
      this.venda.COD_VENDEDOR              = null
      this.venda.COD_MOTORISTA             = null
      this.venda.VL_TOTAL                  = null
      this.venda.OBS2                      = null
      this.venda.OBS3                      = null
      this.venda.LOTE                      = null
      this.venda.TIPO_DOCPAG               = null
      this.venda.N_DOCPAG                  = null
      this.venda.COD_REPRES                = null
      this.venda.COD_CONFERENTE            = null
      this.venda.TIPO_VENDEDOR             = null
      this.venda.ITENS                     = null
      this.venda.NENTREGA                  = '0'
      this.venda.PLACA                     = null
      this.venda.VL_ENTRADA                = null
      this.venda.VL_DESCONTO               = null
      this.venda.CFOP                      = null
      this.venda.UFENT                     = null
      this.venda.TELENT                    = null
      this.venda.CONTATOENT                = null
      this.venda.BAIRROENT                 = null
      this.venda.CIDADEENT                 = null
      this.venda.ENDENT                    = null
      this.venda.USUARIO                   = null
      this.venda.MOT_CANC                  = null
      this.venda.NUMNF                     = null
      this.venda.SERIENF                   = null
      this.venda.UFPLACA                   = null
      this.venda.PORCONTA                  = null
      this.venda.VOLUMES                   = null
      this.venda.PESOLIQUIDO               = 0.00
      this.venda.PESOBRUTO                 = 0.00
      this.venda.TOTALNF                   = null
      this.venda.DT_CANC                   = null
      this.venda.DT_ALTERACAO              = null
      this.venda.TX_USUARIO_ALTERACAO      = null
      this.venda.VL_TOTAL_ANTES_ALTERACAO  = 0.00
      this.venda.VL_BASE_CALC_ICMS         = 0.00
      this.venda.VL_TOTAL_ICMS             = 0.00
      this.venda.VL_BASE_CALC_ST_ICMS      = 0.00
      this.venda.VL_TOTAL_ST_ICMS          = 0.00
      this.venda.VL_TOTAL_IPI              = 0.00
      this.venda.VL_TOTAL_PIS              = 0.00
      this.venda.VL_TOTAL_COFINS           = 0.00
      this.venda.VL_TOTAL_DESCONTO         = 0.00
      this.venda.VL_TOTAL_SEGURO           = 0.00
      this.venda.VL_TOTAL_OUTRAS_DESP      = 0.00
      this.venda.VL_TOTAL_FRETE            = 0.00
      this.venda.NR_PESO_BRUTO             = 0.00
      this.venda.VL_TOTAL_PRODUTOS         = 0.00
      this.venda.NR_PESO_LIQUIDO           = 0.00
      this.venda.VL_TOTAL_NFE              = 0.00
      this.venda.OP_FORMA_PAGTO            = 'V'
      this.venda.TX_USUARIO_CANCELAMENTO   = null
      this.venda.NR_PARCELAS               = null
      this.venda.COD_TRANSP                = null
      this.venda.ORIGEM                    = null
      this.venda.DT_PREVISAO_ENTREGA       = null
      this.venda.HORA                      = null
      this.venda.DT_PEDIDO                 = Tools.getDataAtual(),
      this.venda.DT_SISTEMA_CANCELAMENTO   = null
      this.venda.DT_CADASTRO_SISTEMA       = null
      this.venda.DT_ALTERACAO_SISTEMA      = null
      this.venda.OBSERVACOES               = null
      this.venda.SITUACAO                  = '2'
      this.venda.DT_RETORNO                = null
      this.venda.NOME_RESPONSAVEL_RETORNO  = null
      this.venda.DT_LANCAMENTO_RETORNO     = null
      this.venda.OBS_RETORNO               = null
      this.venda.USUARIO_RETORNO           = null
      this.venda.VL_TOTAL_RETORNO_BKP      = 0.00
      this.venda.VL_TOTAL_RETORNO          = 0.00
      this.venda.DT_LANCAMENTO_WEB         = null
      this.venda.OP_LANCAMENTO_WEB         = null
      this.venda.USUARIO_LANCAMENTO_WEB    = null
      this.venda.OBS_PEDIDO                = null
      this.venda.DT_INICIAR_PAGAMENTO      = null
        

    },
    ajustarCamposTabelaVendas(dados) {
        this.venda.DT_PEDIDO = Tools.formatarDataParaInput(dados.DT_PEDIDO)
        this.venda.DT_INICIAR_PAGAMENTO = Tools.formatarDataParaInput(dados.DT_INICIAR_PAGAMENTO)
        this.venda.DT_SAIDA = Tools.formatarDataParaInput(dados.DT_SAIDA)
        if (this.venda.DT_PAG) {
          this.venda.DT_PAG = Tools.formatarDataParaInput(this.venda.DT_PAG)
        }
    },
    async iniciarFormEditar(id) {
      try {
        const response = await this.$http.get(`/api/protected/vendapedido/getById/${id}`)
        const vendaResponse = response?.data?.[0]

        if (!vendaResponse) {
          throw new Error('O Pedido não foi localizado!')
        }

        this.venda = vendaResponse
        this.ajustarCamposTabelaVendas(this.venda)
        

        this.vlTotalAntes = this.venda.VL_TOTAL_NFE
            
        if (['0','1','6','7'].includes(this.venda.SITUACAO)) {
          this.controles.fechada = true
        } else {
          this.controles.fechada = false
        }
      } catch (err) {
        throw new Error(err.message || err)
      }
    },
    async atualizarPrecoVenda(){
      try {
        const result = await this.$http.get(`api/protected/vendapedido/item/getAchaPrecoLivre/${this.venda.COD_CLI}/${this.item.COD_PRO}`)
        this.item.VL_UNT = result.data[0].PRECO
        this.item.VL_CUSTO = result.data[0].CUSTO
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      }
    },
    async getTipoMovimentacoes() {
      try {
        const response = await this.$http.get(`/api/protected/tipoMovimentacao/listar`)
        const dados = response.data

        this.tipoMovimentacoes.options = []

        if (Array.isArray(dados)) {
          for (const tipo of dados) {
            this.tipoMovimentacoes.options.push({
              value: tipo.ID,
              text: tipo.ID + ' - ' + tipo.DESCRICAO
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em getTipoMovimentacoes:', err)
        return null
      }
    },
    async getConferentes() {
      try {
        const response = await this.$http.get(`/api/protected/funcionario/listar`)
        const dados = response.data

        this.conferentes.options = []

        if (Array.isArray(dados)) {
          for (const conferente of dados) {
            this.tipoMovimentacoes.options.push({
              value: conferente.ID,
              text: conferente.ID + ' - ' + conferente.DESCRICAO
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em getTipoMovimentacoes:', err)
        return null
      }
    },
    async getMotoristas() {
      try {
        const response = await this.$http.get(`/api/protected/funcionario/listar`)
        const dados = response.data

        this.motoristas.options = []

        if (Array.isArray(dados)) {
          for (const motorista of dados) {
            this.motoristas.options.push({
              value: motorista.ID,
              text: motorista.ID + ' - ' + motorista.DESCRICAO
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em getTipoMovimentacoes:', err)
        return null
      }
    },
    async carregarParametros () {
      try {
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/parametro/getDados'))
        const dados = response.data

        return dados?.[0]

      } catch (err) {
        console.error('Erro em carregarParametros:', err)
        return null
      }
    },
    async carregarListaEstoque() {
      try {
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/centroestoque/listartodos'))
        const dados = response.data

        this.estoqueProduto.options = []
        this.estoqueProduto.QUANT = 0.00
        this.estoqueProduto.PECAS = 0

        if (Array.isArray(dados)) {
          for (const estoque of dados) {
            this.estoqueProduto.options.push({
              value: estoque.CODIGO,
              text: estoque.NOME
            })
          }
        }
      } catch (err) {
        console.error('Erro em carregarListaEstoque:', err)
        throw new Error("O estoque está indisponível")
      }
    },
    handleMouseDownAcrescentarItem(item) {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarAcrescimoItem(item);
      }, 500); // 0.5 segundos para começar o incremento contínuo
    },
    handleMouseUpAcrescentarItem(item) {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.acrescentarItemSimples(item);
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveAcrescentarItem() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarAcrescimoItem(item) {
      this.intervaloBotao = setInterval(() => {
        if (item.PECAS_PEDIDO + 10 <= item.PECAS) {
          item.PECAS_PEDIDO += 10;
        } else {
          item.PECAS_PEDIDO = item.PECAS;
          clearInterval(this.intervaloBotao);
        }
      }, 100); // Incrementa 10 a cada 0.1 segundo (100ms)
    },
    acrescentarItemSimples(item) {
      if (item.PECAS_PEDIDO + 1 <= item.PECAS) {
        item.PECAS_PEDIDO += 1;
      } else {
        item.PECAS_PEDIDO = item.PECAS;
      }
    },
    handleMouseDownDecrementarItem(item) {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarDecrementoItem(item);
      }, 500); // 0.5 segundos para começar o decremento contínuo
    },
    handleMouseUpDecrementarItem(item) {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.decrementoItemSimples(item);
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveDecrementarItem() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarDecrementoItem(item) {
      this.intervaloBotao = setInterval(() => {
        if (item.PECAS_PEDIDO - 10 >= 0) {
          item.PECAS_PEDIDO -= 10;
        } else {
          item.PECAS_PEDIDO = 0;
          clearInterval(this.intervaloBotao);
        }
      }, 100); // Decrementa 10 a cada 0.1 segundo (100ms)
    },
    decrementoItemSimples(item) {
      if (item.PECAS_PEDIDO - 1 >= 0) {
        item.PECAS_PEDIDO -= 1;
      } else {
        item.PECAS_PEDIDO = 0;
      }
    },
    handleMouseDownAcrescentarItemAlteracao() {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarAcrescimoItemAlteracao();
      }, 500); // 0.5 segundos para começar o incremento contínuo
    },
    handleMouseUpAcrescentarItemAlteracao() {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.acrescentarItemSimplesAlteracao();
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveAcrescentarItemAlteracao() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarAcrescimoItemAlteracao(item) {
      this.intervaloBotao = setInterval(() => {
        if (this.itemAlteracao.PECAS_PEDIDO + 10 <= this.itemAlteracao.PECAS_ESTOQUE) {
          this.itemAlteracao.PECAS_PEDIDO += 10
        } else {
          this.itemAlteracao.PECAS_PEDIDO = this.itemAlteracao.PECAS_ESTOQUE
          clearInterval(this.intervaloBotao)
        }
      }, 100); // Incrementa 10 a cada 0.1 segundo (100ms)
    },
    acrescentarItemSimplesAlteracao() {
      if (this.itemAlteracao.PECAS_PEDIDO + 1 <= this.itemAlteracao.PECAS_ESTOQUE) {
        this.itemAlteracao.PECAS_PEDIDO += 1
      } else {
        this.itemAlteracao.PECAS_PEDIDO = this.itemAlteracao.PECAS_ESTOQUE
      }
    },
    handleMouseDownDecrementarItemAlteracao() {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarDecrementoItemAlteracao();
      }, 500); // 0.5 segundos para começar o decremento contínuo
    },
    handleMouseUpDecrementarItemAlteracao() {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.decrementoItemSimplesAlteracao();
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveDecrementarItemAlteracao() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarDecrementoItemAlteracao() {
      this.intervaloBotao = setInterval(() => {
        if (this.itemAlteracao.PECAS_PEDIDO - 10 >= 0) {
          this.itemAlteracao.PECAS_PEDIDO -= 10;
        } else {
          this.itemAlteracao.PECAS_PEDIDO = 0;
          clearInterval(this.intervaloBotao);
        }
      }, 100); // Decrementa 10 a cada 0.1 segundo (100ms)
    },
    decrementoItemSimplesAlteracao() {
      if (this.itemAlteracao.PECAS_PEDIDO - 1 >= 0) {
        this.itemAlteracao.PECAS_PEDIDO -= 1;
      } else {
        this.itemAlteracao.PECAS_PEDIDO = 0;
      }
    },
    usarPreco(item) {
      item.VL_UNT = item.ULTIMO_PRECO
    },
    removerPecas(item) {
      if (item.PECAS_PEDIDO > 0 ) {
        item.PECAS_PEDIDO--
      }
    },
    
    
    forceValidation(linha) {
      const maxPecas = parseInt(linha.item.PECAS, 10);
      let currentPecas = parseInt(linha.item.PECAS_PEDIDO, 10);

      if (currentPecas > maxPecas) {
        linha.item.PECAS_PEDIDO = maxPecas;
      }
    },
    colorirLimiteCredito(valor) {
      if (valor === 0) return 'primary'
      else if (valor > 0) return 'success'
      else return 'danger'
    },
    traduzirSituacao(registro) {
      const item = registro && typeof registro === 'object' ? registro : null
      const value = item ? item.SITUACAO : registro
      let $variant
      if ( value == '0'  ) {
        $variant = 'CANCELADO'
      } else if ( value == '1'  ) {
        if (item && this.isEntregaConfirmada(item)) $variant = 'ENTREGUE'
        else if (!item || !item.ORDEM_ENTREGA_ID) $variant = 'FECHADO / AGUARD. CARGA'
        else {
          const statusOrdem = this.getStatusOrdemEntrega(item)
          if (statusOrdem === '1') $variant = 'EM EMBARQUE'
          else if (['2', '3', '4'].includes(statusOrdem)) $variant = 'EMBARCADO'
          else $variant = 'EM EMBARQUE'
        }
      } else if ( value == '2'  ) {
        $variant = 'EM CADASTRO'
      } else if ( value == '3'  ) {
        $variant = 'AGUARDANDO ORDEM'
      } else if ( value == '4'  ) {
        $variant = 'ORDEM EXPEDIÇÃO'
      } else if ( value == '5'  ) {
        $variant = 'EMBARCANDO'
      } else if ( value == '6'  ) {
        $variant = String(this.venda.OP_CONFERENCIA_VENDA || '0').trim() === '1' ? 'CONFERIDO / PRONTO P/ VENDA' : 'EMBARCADO'
      } else if ( value == '7'  ) {
        $variant = 'AGUARDANDO SEPARACAO'
      } else if ( value == '8'  ) {
        $variant = 'EM SEPARACAO'
      }
      return $variant
    },
    async getVendedorId() {
      return new Promise((resolve, reject) => {
        this.$http.get('/api/protected/usuario/getVendedorId?login='+window.localStorage.getItem('login'))
        .then((result) => {
          if ((result.data) && (result.data.VENDEDOR_ID)) {
            this.venda.COD_VENDEDOR = result.data.VENDEDOR_ID
            resolve(true)
            return
          } else {
            reject(false)
            return
          }
          
          
        }).catch((err) => {
          this.$root.$bvToast.toast(`Não foi possível localizar o vendedor!! ${err}`, {
            title: 'Erro',
            autoHideDelay: 100,
            variant: 'danger',
            appendToast: true
          })
          reject(false)
          return
        })
      })
      
    },
    async atualizarEstoqueProduto(){
      if (this.item.COD_CENTRO != null && this.item.COD_PRO != null) {
        if (this.venda.SEQUENCIA != null && this.venda.COD_CLI != null) {
          try {
            const resultPedido = await this.$http.get(`/api/protected/estoque/getEstoqueDoPedidoDeVenda/${this.venda.SEQUENCIA}/${this.venda.COD_CLI}`)
            const itemEstoquePedido = Array.isArray(resultPedido.data)
              ? resultPedido.data.find(produto => Number(produto.PRODUTO_ID) === Number(this.item.COD_PRO))
              : null

            this.estoqueProduto.QUANT = itemEstoquePedido && itemEstoquePedido.QUANT > 0 ? itemEstoquePedido.QUANT : 0.00
            this.estoqueProduto.PECAS = itemEstoquePedido && itemEstoquePedido.PECAS > 0 ? itemEstoquePedido.PECAS : 0
            return
          } catch (err) {
            // Fallback para a consulta bruta quando o saldo liquido do pedido estiver indisponivel.
          }
        }

        try {
          const result = await this.$http.get(`/api/protected/estoque/listarResumoByProdutoIdCentroEstoqueId/${this.item.COD_PRO}/${this.item.COD_CENTRO}`)
          this.estoqueProduto.QUANT = result.data[0].QUANT && result.data[0].QUANT > 0 ? result.data[0].QUANT : 0.00
          this.estoqueProduto.PECAS = result.data[0].PECAS
        } catch(err) {
          this.estoqueProduto.QUANT = 0.00
          this.estoqueProduto.PECAS = 0

          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel verificar o estoque' )
        }
      } else {
        this.estoqueProduto.QUANT = 0.00
        this.estoqueProduto.PECAS = 0
      }
    },
    async atualizarCliente() {
      console.log('atualizando cliente inicio')
      console.log('montagemTelaConcluida:', this.controles.montagemTelaConcluida)
      try {
        const response = await this.$http.get(`/api/protected/clientes/getDetalhesParaVenda/${this.venda.COD_CLI}`)
        const cliente = response.data[0]

        if (!cliente) {
          throw new Error('Cliente não encontrado')
        }

        this.cliente = cliente

        // Situação financeira
        if (cliente.OP_SITUACAO_FINANCEIRO === '1') {
          this.controles.situacaoCliente = 'Cliente: BLOQUEADO'
          this.controles.clienteBloqueado = true
          this.$root.$bvToast.toast(`Cliente Bloqueado!!!`, {
            title: 'Aviso',
            autoHideDelay: 4000,
            variant: 'danger',
            appendToast: true
          })
        } else {
          this.controles.situacaoCliente = 'Cliente: LIBERADO'
          this.controles.clienteBloqueado = false
        }

        
        if (this.controles.montagemTelaConcluida == true) {

          // deve-se tratar this.diasIniciarPagamento aqui antes e depois para evitar que ele fique em branco
          this.diasIniciarPagamento = cliente.DIAS_INICIAR_PAGAMENTO != null ? parseInt(cliente.DIAS_INICIAR_PAGAMENTO) : 0

          // Resetar a forma de pagamento
          this.venda.OP_FORMA_PAGTO = null
          await this.$nextTick()

          // Forma de pagamento
          this.venda.OP_FORMA_PAGTO = cliente.FORMA_PAGAMENTO || 'V'
          //Dias
          this.diasIniciarPagamento = cliente.DIAS_INICIAR_PAGAMENTO != null ? parseInt(cliente.DIAS_INICIAR_PAGAMENTO) : 0
          
          //A parir de
          if (this.diasIniciarPagamento == 30 ) {
            this.venda.DT_INICIAR_PAGAMENTO = Tools.getAcrescentarData(this.venda.DT_PEDIDO, this.diasIniciarPagamento, 'meses')
          } else {
            this.venda.DT_INICIAR_PAGAMENTO = Tools.getAcrescentarData(this.venda.DT_PEDIDO, this.diasIniciarPagamento, 'dias')
          }
            
          //ComboVezes
          this.venda.NR_PARCELAS =  cliente.PRAZO
          //comboDias
          this.venda.PAG1 = cliente.DIAS_ENTRE_PARCELAS?? null
        
        } else {
          this.diasIniciarPagamento = this.venda.DT_INICIAR_PAGAMENTO != null ? parseInt(Tools.getDiasEntreDatas(this.venda.DT_PEDIDO, this.venda.DT_INICIAR_PAGAMENTO)) : 0
        }

        

        return true

      } catch (error) {
        console.error('Erro ao atualizar cliente:', error)
        return false
      }
    },
    async getItens() {
      try {
        const response = await this.$http.get('/api/protected/vendapedido/item/getListagemByVenda/'+this.venda.SEQUENCIA)
        const dados = response.data
        return dados

      } catch (err) {
        console.error('Erro em getItens:', err)
        return null
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
    clearTimeout(this.timerBotao)
    clearInterval(this.intervaloBotao)
  },
  async created () {
    try {
      this.controles.montagemTelaConcluida = false
      try {
        this.$store.commit('controle/setAguardando', true)
        let id = this.$route.params.id
        
        this.parametros =  await this.carregarParametros()
        
        if (!this.parametros) {
          throw new Error(`Os parametros do Sistema não foram carregados!!`)
        }

        if (this.parametros.OP_VENDA_PRECO_POR_TABELA === 'T' ) {
          this.precoTabelado = true
        } else {
          this.precoTabelado = false
        }

        this.controles.expedicaoDireta = this.parametros.OP_EXPEDICAO_DIRETA === '1'
        this.controles.expedicaoConferencia = this.parametros.OP_EXPEDICAO_DIRETA === '2'
        
        if (this.parametros.OP_VENDA_POR_PECAS === 'S') {
          this.controles.vendaPorPecas = true
        } else {
          this.controles.vendaPorPecas = false
        }
        

        try {
          await this.carregarListaEstoque()
        } catch (err) {
          throw new Error(err.message || err)
        }

        
        this.gerarComboParcelas()
        this.gerarDias()

        this.tipoMovimentacoes.itens = await this.getTipoMovimentacoes()
        if (!this.tipoMovimentacoes.itens) {
            throw new Error(`O tipo de movimentação não esta parametrizado no sistema!!`)
        }

        //VENDA EM ALTERACAO
        if ( id ) {
          try {
              await this.iniciarFormEditar( id )
          } catch (err) {
            console.log(err)
            throw new Error(err.message || err)
          }

          
          try {
            
            let result = await this.getItens()
            this.montarTabelaItens(result)
          } catch (err) {
            console.log(err)
            throw new Error(`Os produtos da Venda/Prefatura, não foram encontrados!!`)
          }

          this.vendaIdEditar = id
          this.controles.vendaAlteracao = true
          
          
        } 
        // NOVA VENDA
        else { 
          
          this.limparVenda()

          this.venda.OBSERVACOES = this.parametros.LINHA1ROMA + '\n' + this.parametros.LINHA2ROMA + '\n' + this.parametros.LINHA3ROMA
          this.venda.TIPO_MOVIMENTACAO_ID      = this.parametros.TIPO_MOVIMENTACAO_VENDA_INT_ID
          this.venda.SEQUENCIA                 = null
          this.venda.N_VENDA                   = null
          this.venda.DT_SAIDA                  = Tools.getDataAtual()
          this.venda.DT_PEDIDO                 = Tools.getDataAtual()
          this.venda.DT_INICIAR_PAGAMENTO      = Tools.getDataAtual()
          this.venda.SITUACAO                  = '2'
          this.venda.OP_PEDIDO                 = '1'
          this.venda.PAG2                      = '0'
          this.venda.TIPO_VEN                  = '0'
          this.venda.FORMA                     = 'VENDA'
          this.venda.USUARIO                   = window.localStorage.getItem('login')
          this.venda.USUARIO_LANCAMENTO_WEB    = window.localStorage.getItem('login')
          this.venda.USUARIO_PEDIDO            = window.localStorage.getItem('login')
          this.venda.NENTREGA                  = '0'
          this.venda.VL_TOTAL_RETORNO_BKP      = 0.00
          this.venda.VL_TOTAL_RETORNO          = 0.00
          this.venda.PESOLIQUIDO               = 0.00
          this.venda.PESOBRUTO                 = 0.00
          this.venda.VL_TOTAL_ANTES_ALTERACAO  = 0.00
          this.venda.VL_BASE_CALC_ICMS         = 0.00
          this.venda.VL_TOTAL_ICMS             = 0.00
          this.venda.VL_BASE_CALC_ST_ICMS      = 0.00
          this.venda.VL_TOTAL_ST_ICMS          = 0.00
          this.venda.VL_TOTAL_IPI              = 0.00
          this.venda.VL_TOTAL_PIS              = 0.00
          this.venda.VL_TOTAL_COFINS           = 0.00
          this.venda.VL_TOTAL_DESCONTO         = 0.00
          this.venda.VL_TOTAL_SEGURO           = 0.00
          this.venda.VL_TOTAL_OUTRAS_DESP      = 0.00
          this.venda.VL_TOTAL_FRETE            = 0.00
          this.venda.NR_PESO_BRUTO             = 0.00
          this.venda.VL_TOTAL_PRODUTOS         = 0.00
          this.venda.NR_PESO_LIQUIDO           = 0.00
          this.venda.VL_TOTAL_NFE              = 0.00

          this.vendaIdEditar = null
          this.controles.vendaAlteracao = false
          this.controles.fechada = false
          
          
          
          // ⏳ Delay para garantir que o DOM e refs estejam prontos
          setTimeout(() => {
            try {
              document.addEventListener("keydown", this.handleKeydown)

              const campoCliente = this.$refs.edCOD_CLI?.$refs?.auto?.$refs?.autocomplete
              if (campoCliente && typeof campoCliente.focus === 'function') {
                campoCliente.focus()
              } else {
                console.warn('Campo cliente-pesquisa não encontrado para foco')
              }
            } catch (err) {
              console.error('Erro ao tentar focar o campo cliente-pesquisa:', err)
            }
          }, 200)
          
      

        }
      } catch (err) {
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
        
        return
      }
    } finally {
      this.controles.montagemTelaConcluida = true
      this.$store.commit('controle/setAguardando', false)

      console.log('fim do created')
      console.log('montagemTelaConcluida:', this.controles.montagemTelaConcluida)
    }
  },
  mounted (){
    let id = this.$route.params.id
    if ( id == null  ) {
      //this.$refs.ob_edDocumento.focus()
      this.$refs.edCOD_CLI.$refs.auto.$refs.autocomplete.focus()
    }

    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
      console.log('setTimeout do mounted')
      console.log('montagemTelaConcluida:', this.controles.montagemTelaConcluida)
    }, 200)
  },
  watch: {
    diasIniciarPagamento(novosDias) {
      if (!this.controles.montagemTelaConcluida) return
      if (this.controles.atualizandoDias) return

      this.controles.atualizandoData = true

      this.venda.DT_INICIAR_PAGAMENTO = Tools.getAcrescentarData(this.venda.DT_PEDIDO, novosDias, 'dias')

      this.$nextTick(() => {
        this.controles.atualizandoData = false
      })
    },

    'venda.DT_INICIAR_PAGAMENTO': function(novaData, oldData) {
      if (this.controles.montagemTelaConcluida == false) return
      if (this.controles.atualizandoData) return

      this.controles.atualizandoDias = true

      const dataPedido = moment(this.venda.DT_PEDIDO)
      const dataInicio = moment(novaData)

      let diff = dataInicio.diff(dataPedido, 'days')

      if (diff === 30) {
        this.diasIniciarPagamento = 30
      } else {
        this.diasIniciarPagamento = diff
      }

      this.$nextTick(() => {
        this.controles.atualizandoDias = false
      })
    },
    'venda.COD_CLI': async function (val, oldVal) {
      if (!val) {
        this.cliente.CODIGO = null
        this.cliente.NOME = null
        this.cliente.RAZAOSOCIAL = null
        this.cliente.ID_UF = null
        this.cliente.FIZ_JUR = null
        this.cliente.ISENTO_ICMS = null
        this.cliente.COD_VEND = null
        this.cliente.LIMITE_CREDITO = 0.00
        this.cliente.NOTAS_EM_ABERT0 = 0
        this.cliente.PRAZO = null
        this.cliente.TIPO_CLI = null
        this.cliente.GRUPO_ARECEBER_ID = null
        this.controles.situacaoCliente = 'Cliente:'
        this.controles.clienteBloqueado = false
        return
      }
     
      const sucesso = await this.atualizarCliente()

      if (!sucesso) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel atualizar os dados do Cliente' )
      }
      
    },
    'item.COD_CENTRO': async function(valorNew, valorOld) {
      if (valorNew !== valorOld) {
        this.limparCriticaEstoqueModalItem()
      }
      await this.atualizarEstoqueProduto()
    },
    'item.COD_PRO': async function (valorNew, valorOld) {
      if (valorNew !== valorOld) {
        this.limparCriticaEstoqueModalItem()
      }
      if (this.item.COD_PRO) {
        await this.atualizarEstoqueProduto()
        await this.atualizarPrecoVenda()
      } 
    },
    'venda.OP_FORMA_PAGTO': function(valorNew, valorOld) {
      if (this.controles.montagemTelaConcluida == false) return

      //Se nao tem forma de pagamento ou foi setado A VISTA
      if ((!valorNew) || (valorNew === 'V')) {
        this.venda.NR_PARCELAS = 1
        this.venda.PAG1 = 0
        this.venda.DT_INICIAR_PAGAMENTO = Tools.getDataAtual()
      }
    }


    
  }
}
</script>
<style scoped>
.autonumeric_required{
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 0px;
  /* padding: 0.35rem 0.75rem; */
  padding: 0.35rem 0.75rem;
  border-color: #f86c6b;
}
/* Simula o verde de validação */
.autonumeric_is-valid {
  border-color: #28a745 !important;
  background-color: #fff;
}

/* PREMIUM UI STYLES */
.page-shell {
  background-color: #f4f7f9;
  min-height: 100vh;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.rounded-lg {
  border-radius: 1rem !important;
}

.transition-hover {
  transition: all 0.3s ease;
}

.transition-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(0,0,0,0.1) !important;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(135deg, #28a745 0%, #218838 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%) !important;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white !important;
  font-weight: 600;
  padding: 0.5rem 1.25rem;
  border-radius: 50px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.btn-glass:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.btn-glass-success:hover { background: rgba(40, 167, 69, 0.8); }
.btn-glass-info:hover { background: rgba(23, 162, 184, 0.8); }
.btn-glass-primary:hover { background: rgba(0, 123, 255, 0.8); }
.btn-glass-danger:hover { background: rgba(220, 53, 69, 0.8); }

.modal-header-premium {
  border-bottom: 0;
  position: relative;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.bg-warning-soft {
  background-color: rgba(255, 193, 7, 0.15) !important;
}

.stock-banner-modal {
  background: #fff7ed;
  border: 1px solid #fdba74;
  border-radius: 10px;
  padding: 10px 12px;
  color: #9a3412;
}

.stock-banner-title {
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.stock-banner-message {
  font-size: 0.72rem;
  font-weight: 600;
  margin-bottom: 6px;
}

.stock-banner-item {
  font-size: 0.72rem;
  line-height: 1.4;
}

/* Custom Pill Group for Numeric Inputs */
.cec-pill-group {
  display: flex;
  align-items: stretch;
  border-radius: 50px;
  overflow: hidden;
  background: #fff;
}

.cec-pill-left {
  border-top-left-radius: 50px !important;
  border-bottom-left-radius: 50px !important;
  border-right: 0 !important;
}

.cec-pill-right {
  border-top-right-radius: 50px !important;
  border-bottom-right-radius: 50px !important;
  border-left: 0 !important;
}

.cec-pill-append .btn {
  margin: 0 !important;
  height: 100%;
  display: flex;
  align-items: center;
}

.opacity-75 {
  opacity: 0.75;
}

.table-premium thead th {
  background-color: #f8f9fa;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  font-weight: 700;
  border-top: 0;
  border-bottom: 2px solid #e9ecef;
  color: #495057;
  padding: 1rem 0.75rem;
}

.table-premium tbody td {
  padding: 1rem 0.75rem;
  vertical-align: middle;
  border-bottom: 1px solid #f1f3f5;
}

.table-premium tbody tr:hover {
  background-color: rgba(74, 144, 226, 0.03);
}
</style>





// WEBPACK FOOTER //
// src/views/movimentos/pedidovenda/PedidoVendaCadastroWeb.vue